//// ═══════════════════════════════════════════════════════════════════
////  CropData.js  —  Bhuhit Agri Intelligence
////  Separate component: Crop Calendar + Yield Params + Spectral Hints
////  75 Maharashtra crops — Kharif / Rabi / Zaid / Perennial
////  Accuracy sources: ICAR, MAHA Agriculture Dept, NDDB
//// ═══════════════════════════════════════════════════════════════════

//// ── Stage template helpers ───────────────────────────────────────
//const stg = (name, mr, hi, te, weeks, ndvi, icon) =>
//    ({ name, mr, hi, te, weeks, ndviRange: ndvi, icon });

//// ── CROP_CALENDAR ────────────────────────────────────────────────
//// Each crop:
////   season  : Kharif | Rabi | Zaid | Perennial
////   color   : dashboard accent hex
////   stages  : array of growth stages with NDVI ranges
////   ndviPeak: expected peak NDVI (for health scoring)
////   note    : brief agronomic note
//export const CROP_CALENDAR = {

//    // ── CEREALS ─────────────────────────────────────────────────────
//    "Rice": {
//        season: "Kharif", color: "#39FF14", ndviPeak: 0.72,
//        note: "Flood-tolerant. LSWI high at transplanting.",
//        stages: [
//            stg("Land Prep", "जमीन तयारी", "भूमि तैयारी", "నేల తయారీ", [0, 2], [0.05, 0.18], "🌱"),
//            stg("Transplanting", "रोप लावणी", "रोपाई", "నాట్లు వేయడం", [2, 4], [0.10, 0.28], "🌿"),
//            stg("Tillering", "फुटवे अवस्था", "कल्ले निकलना", "తనులు వేయడం", [4, 8], [0.25, 0.58], "🌾"),
//            stg("Panicle Init.", "लोंबी निर्मिती", "बाली निकलना", "పానికిల్", [8, 12], [0.55, 0.78], "🌾"),
//            stg("Heading", "लोंबी बाहेर", "शीर्ष", "హెడింగ్", [12, 16], [0.62, 0.85], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [16, 20], [0.45, 0.72], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [20, 24], [0.15, 0.45], "🚜"),
//        ]
//    },
//    "Wheat": {
//        season: "Rabi", color: "#FFB800", ndviPeak: 0.70,
//        note: "Winter crop. Cool nights boost grain protein.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Germination", "उगवण", "अंकुरण", "అంకురోద్గమం", [2, 4], [0.10, 0.20], "🌿"),
//            stg("Tillering", "फुटवे", "कल्ले", "తనులు", [4, 8], [0.25, 0.45], "🌾"),
//            stg("Jointing", "जोडणी", "जोड़", "జాయింటింగ్", [8, 12], [0.45, 0.65], "🌾"),
//            stg("Heading", "शीर्ष", "शीर्ष", "హెడింగ్", [12, 14], [0.65, 0.78], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [14, 18], [0.55, 0.70], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 22], [0.20, 0.35], "🚜"),
//        ]
//    },
//    "Maize/Corn": {
//        season: "Kharif", color: "#FB923C", ndviPeak: 0.78,
//        note: "High water demand at tasseling. Watch for fall armyworm.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.25], "🌿"),
//            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.40, 0.65], "🌽"),
//            stg("Tasseling", "तुरा येणे", "बाल निकलना", "పుప్పొడి", [8, 10], [0.65, 0.82], "🌾"),
//            stg("Silking", "रेशीम येणे", "सिल्किंग", "సిల్కింగ్", [10, 12], [0.68, 0.82], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [12, 16], [0.55, 0.70], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [16, 20], [0.20, 0.40], "🚜"),
//        ]
//    },
//    "Jowar/Sorghum": {
//        season: "Kharif", color: "#C2410C", ndviPeak: 0.70,
//        note: "Drought tolerant. Dual-purpose: grain + fodder.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 3], [0.10, 0.22], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 7], [0.35, 0.60], "🌿"),
//            stg("Booting", "खोड फुगणे", "बूटिंग", "బూటింగ్", [7, 9], [0.55, 0.72], "🌾"),
//            stg("Heading", "शीर्ष", "शीर्ष", "హెడింగ్", [9, 11], [0.60, 0.75], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [11, 14], [0.45, 0.65], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [14, 18], [0.18, 0.38], "🚜"),
//        ]
//    },
//    "Bajra/Millet": {
//        season: "Kharif", color: "#D97706", ndviPeak: 0.65,
//        note: "Sandy soil tolerant. Very drought hardy.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [1, 2], [0.10, 0.20], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.30, 0.55], "🌿"),
//            stg("Earhead", "कणीस", "सिट्टा", "ఈలు", [6, 8], [0.50, 0.68], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [8, 11], [0.40, 0.60], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [11, 14], [0.15, 0.32], "🚜"),
//        ]
//    },
//    "Ragi/Finger Millet": {
//        season: "Kharif", color: "#92400E", ndviPeak: 0.62,
//        note: "High calcium. Suitable for dry regions.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 5], [0.25, 0.50], "🌿"),
//            stg("Earhead", "कणीस", "सिट्टा", "ఈలు", [5, 7], [0.45, 0.62], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [7, 10], [0.35, 0.55], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [10, 13], [0.15, 0.30], "🚜"),
//        ]
//    },
//    "Barley": {
//        season: "Rabi", color: "#A3E635", ndviPeak: 0.65,
//        note: "Tolerates saline soils better than wheat.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Tillering", "फुटवे", "कल्ले", "తనులు", [2, 6], [0.20, 0.45], "🌾"),
//            stg("Heading", "शीर्ष", "शीर्ष", "హెడింగ్", [6, 9], [0.55, 0.70], "🌾"),
//            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [9, 13], [0.45, 0.62], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [13, 16], [0.18, 0.32], "🚜"),
//        ]
//    },

//    // ── OILSEEDS ─────────────────────────────────────────────────────
//    "Soybean": {
//        season: "Kharif", color: "#A78BFA", ndviPeak: 0.68,
//        note: "Fixes nitrogen. Critical water at R3-R6 stages.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.25], "🌿"),
//            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.35, 0.60], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 10], [0.55, 0.70], "🌸"),
//            stg("Pod Fill", "शेंगा भरणे", "फलियां भरना", "శింగాలు నిండటం", [10, 14], [0.55, 0.70], "🌻"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [14, 16], [0.35, 0.55], "🟡"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [16, 18], [0.15, 0.30], "🚜"),
//        ]
//    },
//    "Groundnut": {
//        season: "Kharif", color: "#D97706", ndviPeak: 0.65,
//        note: "Calcium critical at pegging. Avoid waterlogging.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.22], "🌿"),
//            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 11], [0.50, 0.65], "🌸"),
//            stg("Pegging", "पेग निर्मिती", "पेगिंग", "పెగ్గింగ్", [11, 14], [0.55, 0.68], "🥜"),
//            stg("Pod Dev.", "शेंगा विकास", "फलियां भरना", "శింగాలు", [14, 18], [0.48, 0.62], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 22], [0.20, 0.35], "🚜"),
//        ]
//    },
//    "Sunflower": {
//        season: "Kharif", color: "#FBBF24", ndviPeak: 0.68,
//        note: "Heliotropic. Deep taproot tolerates moderate drought.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.12, 0.25], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.35, 0.58], "🌿"),
//            stg("Bud Stage", "कळी", "कली", "మొగ్గ", [8, 10], [0.55, 0.68], "🌸"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 13], [0.62, 0.75], "🌻"),
//            stg("Seed Fill", "बीज भरणे", "बीज भरना", "విత్తన నిండటం", [13, 17], [0.40, 0.60], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [17, 21], [0.18, 0.35], "🚜"),
//        ]
//    },
//    "Mustard/Rapeseed": {
//        season: "Rabi", color: "#FEF08A", ndviPeak: 0.60,
//        note: "Quick crop 90-110 days. Sensitive to frost at flowering.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 5], [0.25, 0.45], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 8], [0.45, 0.62], "🌸"),
//            stg("Pod Fill", "शेंगा भरणे", "फलियां भरना", "శింగాలు", [8, 11], [0.40, 0.58], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [11, 14], [0.18, 0.30], "🚜"),
//        ]
//    },
//    "Sesame/Til": {
//        season: "Kharif", color: "#FDE68A", ndviPeak: 0.58,
//        note: "Drought tolerant. Avoid waterlogged soils.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 5], [0.22, 0.45], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.40, 0.58], "🌸"),
//            stg("Capsule", "कॅप्सूल", "कैप्सूल", "క్యాప్సూల్", [7, 10], [0.35, 0.52], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [10, 12], [0.15, 0.28], "🚜"),
//        ]
//    },
//    "Linseed/Flax": {
//        season: "Rabi", color: "#BFDBFE", ndviPeak: 0.55,
//        note: "Dual-use: oil seed and fibre. Cool season crop.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.20, 0.42], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 8], [0.40, 0.55], "🌸"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [8, 11], [0.18, 0.30], "🚜"),
//        ]
//    },
//    "Castor": {
//        season: "Kharif", color: "#7C3AED", ndviPeak: 0.65,
//        note: "Industrial crop. Deep roots. Grows in marginal land.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"),
//            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [2, 8], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.50, 0.65], "🌸"),
//            stg("Capsule", "कॅप्सूल", "कैप्सूल", "క్యాప్సూల్", [12, 18], [0.40, 0.60], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 24], [0.22, 0.38], "🚜"),
//        ]
//    },

//    // ── PULSES ───────────────────────────────────────────────────────
//    "Gram/Chickpea": {
//        season: "Rabi", color: "#FACC15", ndviPeak: 0.45,
//        note: "Nitrogen fixing. Susceptible to pod borer at flowering.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.20], "🌿"),
//            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.20, 0.38], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 10], [0.35, 0.48], "🌸"),
//            stg("Pod Dev.", "शेंगा विकास", "फलियां भरना", "శింగాలు", [10, 14], [0.38, 0.48], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [14, 18], [0.15, 0.30], "🚜"),
//        ]
//    },
//    "Tur/Pigeon Pea": {
//        season: "Kharif", color: "#86EFAC", ndviPeak: 0.60,
//        note: "Long duration 150-180 days. Deep rooted perennial shrub.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 10], [0.25, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 14], [0.45, 0.62], "🌸"),
//            stg("Pod Fill", "शेंगा भरणे", "फलियां भरना", "శింగాలు", [14, 18], [0.40, 0.58], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 22], [0.20, 0.35], "🚜"),
//        ]
//    },
//    "Moong/Green Gram": {
//        season: "Kharif", color: "#4ADE80", ndviPeak: 0.55,
//        note: "Short duration 60-70 days. Good for intercropping.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.20, 0.45], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.42, 0.55], "🌸"),
//            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [6, 9], [0.38, 0.52], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [9, 11], [0.15, 0.28], "🚜"),
//        ]
//    },
//    "Udid/Black Gram": {
//        season: "Kharif", color: "#374151", ndviPeak: 0.52,
//        note: "Short 65-80 days. Important dal crop. Avoid excess moisture.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.18, 0.42], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.38, 0.52], "🌸"),
//            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [6, 9], [0.32, 0.48], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [9, 11], [0.12, 0.25], "🚜"),
//        ]
//    },
//    "Masoor/Lentil": {
//        season: "Rabi", color: "#F87171", ndviPeak: 0.48,
//        note: "Cold tolerant. Low water requirement.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.18, 0.38], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 8], [0.35, 0.48], "🌸"),
//            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [8, 12], [0.30, 0.45], "🌻"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [12, 15], [0.12, 0.25], "🚜"),
//        ]
//    },
//    "Rajma/Kidney Bean": {
//        season: "Kharif", color: "#BE123C", ndviPeak: 0.62,
//        note: "Cool highland variety. Sensitive to high temperatures.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.28, 0.50], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 9], [0.45, 0.62], "🌸"),
//            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [9, 13], [0.42, 0.58], "🫘"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [13, 16], [0.18, 0.32], "🚜"),
//        ]
//    },

//    // ── CASH CROPS ───────────────────────────────────────────────────
//    "Cotton": {
//        season: "Kharif", color: "#38BDF8", ndviPeak: 0.65,
//        note: "Bt cotton predominant. Watch pink bollworm.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 3], [0.05, 0.20], "🌱"),
//            stg("Seedling", "रोपण", "पौध", "మొలకలు", [3, 6], [0.15, 0.30], "🌿"),
//            stg("Squaring", "कळी येणे", "कली बनना", "మొగ్గ రావడం", [6, 10], [0.35, 0.55], "🌸"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 14], [0.50, 0.70], "🌸"),
//            stg("Boll Dev.", "बोंड विकास", "टिण्डा विकास", "బొబ్బ విస్తరణ", [14, 20], [0.55, 0.72], "🔵"),
//            stg("Boll Opening", "बोंड उघडणे", "टिण्डा खुलना", "బొబ్బ తెరవడం", [20, 26], [0.30, 0.50], "☁️"),
//            stg("Harvest", "वेचणी", "चुनाई", "సేకరణ", [26, 32], [0.15, 0.30], "🚜"),
//        ]
//    },
//    "Sugarcane": {
//        season: "Kharif", color: "#22C55E", ndviPeak: 0.80,
//        note: "Long duration 10-18 months. Highest water user.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.10, 0.25], "🌱"),
//            stg("Germination", "उगवण", "अंकुरण", "అంకురం", [4, 8], [0.20, 0.40], "🌿"),
//            stg("Tillering", "फुटवे", "कल्ले", "తనులు", [8, 16], [0.40, 0.65], "🌿"),
//            stg("Grand Growth", "मोठी वाढ", "ग्रांड ग्रोथ", "పెద్ద వృద్ధి", [16, 32], [0.65, 0.85], "🌿"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [32, 44], [0.55, 0.75], "🟡"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [44, 52], [0.35, 0.55], "🚜"),
//        ]
//    },
//    "Turmeric": {
//        season: "Kharif", color: "#EAB308", ndviPeak: 0.72,
//        note: "Shade tolerant. 7-9 months. Rhizome crop.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.20], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 6], [0.20, 0.40], "🌿"),
//            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [6, 14], [0.45, 0.70], "🌿"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [14, 28], [0.55, 0.75], "🟡"),
//            stg("Senescence", "पर्णपात", "पत्तों का झड़ना", "ఆకు రాలడం", [28, 36], [0.30, 0.50], "🍂"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [36, 40], [0.10, 0.25], "🚜"),
//        ]
//    },
//    "Ginger": {
//        season: "Kharif", color: "#CA8A04", ndviPeak: 0.68,
//        note: "Shade beneficial. High humidity requirement.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.18], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 5], [0.18, 0.35], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 14], [0.40, 0.68], "🌿"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [14, 22], [0.30, 0.50], "🟡"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [22, 26], [0.12, 0.28], "🚜"),
//        ]
//    },
//    "Tobacco": {
//        season: "Rabi", color: "#78716C", ndviPeak: 0.65,
//        note: "Requires specific curing. Sensitive to soil pH.",
//        stages: [
//            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 4], [0.08, 0.22], "🌱"),
//            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [4, 6], [0.20, 0.38], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [6, 12], [0.45, 0.65], "🌿"),
//            stg("Topping", "शेंडा खुडणे", "टॉपिंग", "టాపింగ్", [12, 14], [0.55, 0.68], "✂️"),
//            stg("Harvest", "कापणी", "तुड़ाई", "కోత", [14, 18], [0.35, 0.55], "🚜"),
//        ]
//    },
//    "Jute": {
//        season: "Kharif", color: "#A16207", ndviPeak: 0.75,
//        note: "Fibre crop. High rainfall requirement. Grows fast.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 10], [0.40, 0.72], "🌿"),
//            stg("Harvest", "कापणी", "कटाई", "కోత", [10, 14], [0.35, 0.60], "🚜"),
//        ]
//    },

//    // ── VEGETABLES ───────────────────────────────────────────────────
//    "Onion": {
//        season: "Rabi", color: "#F97316", ndviPeak: 0.32,
//        note: "Very low NDVI — narrow leaves. Bolting risk in warm weather.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 3], [0.05, 0.15], "🌱"),
//            stg("Seedling", "रोपण", "पौध", "మొలకలు", [3, 6], [0.10, 0.22], "🌿"),
//            stg("Bulb Init.", "कांदा सुरू", "बल्ब शुरू", "బల్బ్ ఆరంభం", [6, 12], [0.18, 0.32], "🧅"),
//            stg("Bulb Growth", "कांदा वाढ", "बल्ब बड़ा", "బల్బ్ వృద్ధి", [12, 18], [0.22, 0.38], "🧅"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [18, 22], [0.15, 0.28], "🟡"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [22, 26], [0.10, 0.20], "🚜"),
//        ]
//    },
//    "Tomato": {
//        season: "Kharif", color: "#EF4444", ndviPeak: 0.65,
//        note: "High value. Temperature sensitive at fruit set.",
//        stages: [
//            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
//            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [3, 5], [0.15, 0.30], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [9, 12], [0.45, 0.65], "🌸"),
//            stg("Fruit Set", "फळ बांधणी", "फल बंधन", "పండు", [12, 15], [0.50, 0.70], "🍅"),
//            stg("Ripening", "पिकणे", "पकना", "పండు పక్వం", [15, 18], [0.35, 0.55], "🍅"),
//            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [18, 22], [0.25, 0.45], "🚜"),
//        ]
//    },
//    "Chilli": {
//        season: "Kharif", color: "#DC2626", ndviPeak: 0.60,
//        note: "Long season 180+ days. Thrips and mites common.",
//        stages: [
//            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 4], [0.05, 0.18], "🌱"),
//            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [4, 6], [0.15, 0.30], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [6, 10], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 14], [0.45, 0.62], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [14, 18], [0.45, 0.60], "🌶️"),
//            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [18, 26], [0.35, 0.55], "🚜"),
//        ]
//    },
//    "Brinjal/Eggplant": {
//        season: "Kharif", color: "#7C3AED", ndviPeak: 0.65,
//        note: "Long harvest period. Shoot and fruit borer vigilance.",
//        stages: [
//            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
//            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [3, 5], [0.15, 0.28], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [9, 12], [0.45, 0.65], "🌸"),
//            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [12, 30], [0.40, 0.62], "🚜"),
//        ]
//    },
//    "Bhendi/Okra": {
//        season: "Kharif", color: "#65A30D", ndviPeak: 0.60,
//        note: "Fast growing. 55-60 days to first harvest.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.25, 0.50], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.45, 0.62], "🌸"),
//            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [6, 14], [0.42, 0.60], "🚜"),
//        ]
//    },
//    "Cauliflower": {
//        season: "Rabi", color: "#F8FAFC", ndviPeak: 0.58,
//        note: "Cool weather essential for curd formation.",
//        stages: [
//            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.28, 0.50], "🌿"),
//            stg("Curd Form.", "फूल बनणे", "फूलगोभी", "గొబ్బెర", [8, 12], [0.38, 0.58], "🥦"),
//            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [12, 16], [0.32, 0.50], "🚜"),
//        ]
//    },
//    "Cabbage": {
//        season: "Rabi", color: "#86EFAC", ndviPeak: 0.62,
//        note: "Heavy feeder. Tip burn in high temperatures.",
//        stages: [
//            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.30, 0.55], "🌿"),
//            stg("Heading", "डोके बनणे", "हेडिंग", "హెడింగ్", [8, 12], [0.42, 0.62], "🥬"),
//            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [12, 15], [0.35, 0.52], "🚜"),
//        ]
//    },
//    "Carrot": {
//        season: "Rabi", color: "#F97316", ndviPeak: 0.55,
//        note: "Root crop. Loose deep soil preferred.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 7], [0.22, 0.45], "🌿"),
//            stg("Root Dev.", "मूळ विकास", "जड़ विकास", "మూల వృద్ధి", [7, 12], [0.30, 0.52], "🥕"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [12, 15], [0.25, 0.42], "🚜"),
//        ]
//    },
//    "Radish/Mula": {
//        season: "Rabi", color: "#FB7185", ndviPeak: 0.50,
//        note: "Very fast 25-30 days. Sow repeatedly.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्పतिक", "వృక్ష దశ", [1, 3], [0.20, 0.40], "🌿"),
//            stg("Root Dev.", "मूळ विकास", "जड़ विकास", "మూల వృద్ధి", [3, 5], [0.28, 0.48], "🌰"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [5, 7], [0.20, 0.38], "🚜"),
//        ]
//    },
//    "Garlic": {
//        season: "Rabi", color: "#FEF9C3", ndviPeak: 0.42,
//        note: "Long season 150-180 days. NDVI very low — narrow leaves.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 12], [0.18, 0.38], "🌿"),
//            stg("Bulbing", "बल्ब", "बल्ब", "బల్బ్", [12, 20], [0.22, 0.40], "🧄"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [20, 24], [0.15, 0.28], "🟡"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [24, 26], [0.10, 0.22], "🚜"),
//        ]
//    },
//    "Potato": {
//        season: "Rabi", color: "#D97706", ndviPeak: 0.72,
//        note: "Cool weather. Critical moisture at tuber initiation.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.20], "🌱"),
//            stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 5], [0.20, 0.38], "🌿"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.45, 0.68], "🌿"),
//            stg("Tuber Init.", "कंद", "कंद", "దుంప", [9, 12], [0.55, 0.72], "🥔"),
//            stg("Tuber Fill", "कंद भरणे", "कंद भरना", "దుంప నిండటం", [12, 16], [0.45, 0.65], "🥔"),
//            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [16, 18], [0.22, 0.38], "🟡"),
//            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [18, 21], [0.10, 0.25], "🚜"),
//        ]
//    },
//    "Methi/Fenugreek": {
//        season: "Rabi", color: "#4ADE80", ndviPeak: 0.52,
//        note: "Cool season herb. Used as green vegetable and spice.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.22, 0.45], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.38, 0.52], "🌸"),
//            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [6, 8], [0.25, 0.42], "🚜"),
//        ]
//    },
//    "Spinach": {
//        season: "Rabi", color: "#22C55E", ndviPeak: 0.58,
//        note: "Multiple cuts. High nitrogen requirement.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.30, 0.55], "🌿"),
//            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [4, 8], [0.35, 0.55], "🚜"),
//        ]
//    },
//    "Coriander": {
//        season: "Rabi", color: "#86EFAC", ndviPeak: 0.48,
//        note: "Short 45-60 days. Often intercropped.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्పतिक", "వృక్ష దశ", [1, 4], [0.20, 0.42], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.35, 0.48], "🌸"),
//            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [6, 8], [0.22, 0.38], "🚜"),
//        ]
//    },
//    "Lauki/Bottle Gourd": {
//        season: "Kharif", color: "#6EE7B7", ndviPeak: 0.62,
//        note: "Climber. High water but poor drainage tolerance.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
//            stg("Germination", "उगवण", "अंकुरण", "అంకురం", [2, 3], [0.12, 0.25], "🌿"),
//            stg("Vine Growth", "वेल वाढ", "लता वृद्धि", "తీగ వృద్ధి", [3, 6], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 8], [0.45, 0.65], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [8, 12], [0.50, 0.70], "🥗"),
//            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [12, 18], [0.35, 0.55], "🚜"),
//        ]
//    },
//    "Bitter Gourd": {
//        season: "Kharif", color: "#4D7C0F", ndviPeak: 0.60,
//        note: "Climber. Grows fast in warm humid conditions.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"),
//            stg("Vine Growth", "वेल वाढ", "लता वृद्धि", "తీగ వృద్ధి", [2, 5], [0.28, 0.52], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.42, 0.60], "🌸"),
//            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [7, 14], [0.38, 0.58], "🚜"),
//        ]
//    },
//    "Pumpkin": {
//        season: "Kharif", color: "#F97316", ndviPeak: 0.65,
//        note: "Heavy vine. Large leaves — high NDVI.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"),
//            stg("Vine Growth", "वेल", "लता", "తీగ", [2, 5], [0.30, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 8], [0.48, 0.65], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [8, 14], [0.52, 0.68], "🎃"),
//            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [14, 18], [0.30, 0.50], "🚜"),
//        ]
//    },
//    "Cowpea": {
//        season: "Kharif", color: "#84CC16", ndviPeak: 0.58,
//        note: "Heat and drought tolerant. Fast 60-90 days.",
//        stages: [
//            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 5], [0.25, 0.50], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.42, 0.58], "🌸"),
//            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [7, 10], [0.38, 0.55], "🌻"),
//            stg("Harvest", "काढणी", "कटाई", "కోత", [10, 13], [0.18, 0.32], "🚜"),
//        ]
//    },

//    // ── FRUITS ───────────────────────────────────────────────────────
//    "Banana": {
//        season: "Kharif", color: "#FBBF24", ndviPeak: 0.72,
//        note: "High water demand. Wind-sensitive. 12-15 months.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.20, 0.40], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 20], [0.50, 0.72], "🌿"),
//            stg("Shooting", "लोंबी", "शूटिंग", "పుష్పించడం", [20, 28], [0.55, 0.72], "🌿"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [28, 40], [0.48, 0.65], "🍌"),
//            stg("Harvest", "काढणी", "कटाई", "కోత", [40, 52], [0.38, 0.55], "🚜"),
//        ]
//    },
//    "Mango": {
//        season: "Rabi", color: "#F59E0B", ndviPeak: 0.68,
//        note: "Perennial. Flowering requires cool dry spell.",
//        stages: [
//            stg("Dormancy", "सुप्तावस्था", "सुप्त अवस्था", "నిద్ర", [0, 8], [0.35, 0.50], "🌳"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.38, 0.55], "🌸"),
//            stg("Fruit Set", "फळ बांधणी", "फल बंधन", "పండు", [12, 16], [0.45, 0.60], "🥭"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు వృద్ధి", [16, 28], [0.55, 0.68], "🥭"),
//            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [28, 34], [0.45, 0.60], "🚜"),
//        ]
//    },
//    "Grape": {
//        season: "Rabi", color: "#7C3AED", ndviPeak: 0.62,
//        note: "Trellised vine. Critical pruning for berry size.",
//        stages: [
//            stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 4], [0.10, 0.25], "✂️"),
//            stg("Budbreak", "कळी", "अंकुर", "మొగ్గ", [4, 6], [0.18, 0.35], "🌿"),
//            stg("Shoot Dev.", "वाढ", "वृद्धि", "అంకురం", [6, 12], [0.40, 0.62], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [12, 15], [0.45, 0.58], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [15, 22], [0.48, 0.62], "🍇"),
//            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [22, 28], [0.35, 0.52], "🚜"),
//        ]
//    },
//    "Pomegranate": {
//        season: "Kharif", color: "#BE185D", ndviPeak: 0.58,
//        note: "Drought tolerant. Prefers dry climate during fruiting.",
//        stages: [
//            stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 3], [0.10, 0.22], "✂️"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.30, 0.52], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.38, 0.55], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [12, 22], [0.42, 0.58], "🍈"),
//            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [22, 28], [0.32, 0.48], "🚜"),
//        ]
//    },
//    "Papaya": {
//        season: "Kharif", color: "#F97316", ndviPeak: 0.65,
//        note: "Fast fruiting 6-9 months. Wind sensitive. Needs drainage.",
//        stages: [
//            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.10, 0.25], "🌱"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.40, 0.60], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.45, 0.62], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [12, 20], [0.48, 0.65], "🍈"),
//            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [20, 30], [0.38, 0.55], "🚜"),
//        ]
//    },
//    "Orange/Sweet Lime": {
//        season: "Rabi", color: "#F97316", ndviPeak: 0.65,
//        note: "Vidarbha speciality. Requires stress irrigation for flowering.",
//        stages: [
//            stg("Dormancy", "विश्राम", "सुप्त", "నిద్ర", [0, 6], [0.38, 0.52], "🌳"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 10], [0.40, 0.55], "🌸"),
//            stg("Fruit Set", "फळ बांधणी", "फल बंधन", "పండు", [10, 14], [0.45, 0.60], "🍊"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు వృద్ధి", [14, 28], [0.50, 0.65], "🍊"),
//            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [28, 34], [0.42, 0.58], "🚜"),
//        ]
//    },
//    "Guava": {
//        season: "Kharif", color: "#86EFAC", ndviPeak: 0.62,
//        note: "Two crops/year in India. Hardy and drought tolerant.",
//        stages: [
//            stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 2], [0.15, 0.28], "✂️"),
//            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.35, 0.55], "🌿"),
//            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 9], [0.42, 0.58], "🌸"),
//            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [9, 16], [0.45, 0.62], "🍈"),
//            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [16, 20], [0.38, 0.52], "🚜"),
//        ]
//    },

//    // ── ADDITIONAL CROPS ─────────────────────────────────────────────
//    "Watermelon": {
//        season: "Zaid", color: "#22C55E", ndviPeak: 0.55, note: "Warm season vine. Needs warm nights for sugar.",
//        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"), stg("Vine Growth", "वेल", "लता", "తీగ", [2, 5], [0.25, 0.50], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.40, 0.58], "🌸"), stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [7, 12], [0.42, 0.58], "🍉"), stg("Harvest", "काढणी", "कटाई", "కోత", [12, 16], [0.28, 0.45], "🚜")]
//    },
//    "Muskmelon": {
//        season: "Zaid", color: "#FEF08A", ndviPeak: 0.52, note: "Dry heat ideal. Short 80-100 days.",
//        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"), stg("Vine Growth", "वेल", "लता", "తీగ", [2, 4], [0.22, 0.45], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.38, 0.52], "🌸"), stg("Harvest", "काढणी", "कटाई", "కోత", [10, 14], [0.25, 0.40], "🚜")]
//    },
//    "Cucumber": {
//        season: "Kharif", color: "#84CC16", ndviPeak: 0.60, note: "Fast 45-55 days. High water at fruit set.",
//        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"), stg("Vine Growth", "वेल वाढ", "लता", "తీగ", [1, 4], [0.25, 0.50], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.42, 0.60], "🌸"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [6, 12], [0.40, 0.58], "🥒")]
//    },
//    "Capsicum": {
//        season: "Rabi", color: "#EF4444", ndviPeak: 0.62, note: "High value export. Temperature 15-25°C ideal.",
//        stages: [stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 4], [0.05, 0.18], "🌱"), stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [4, 6], [0.15, 0.30], "🌿"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [6, 10], [0.32, 0.55], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 13], [0.45, 0.62], "🌸"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [13, 22], [0.40, 0.60], "🫑")]
//    },
//    "Sweet Potato": {
//        season: "Kharif", color: "#F97316", ndviPeak: 0.60, note: "Vine crop. Tolerates marginal soils.",
//        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 2], [0.05, 0.18], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 8], [0.32, 0.55], "🌿"), stg("Tuber Dev.", "कंद", "कंद", "దుంప", [8, 14], [0.42, 0.60], "🍠"), stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [14, 18], [0.28, 0.45], "🚜")]
//    },
//    "Potato": {
//        season: "Rabi", color: "#D97706", ndviPeak: 0.72, note: "Cool weather. Critical moisture at tuber initiation.",
//        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.20], "🌱"), stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 5], [0.20, 0.38], "🌿"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.45, 0.68], "🌿"), stg("Tuber Fill", "कंद भरणे", "कंद भरना", "దుంప నిండటం", [9, 16], [0.45, 0.65], "🥔"), stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [16, 21], [0.10, 0.25], "🚜")]
//    },
//    "Coconut": {
//        season: "Perennial", color: "#78716C", ndviPeak: 0.70, note: "Perennial palm. Sandy coastal soils.",
//        stages: [stg("Young", "तरुण", "युवा", "యువ", [0, 52], [0.40, 0.60], "🌴"), stg("Bearing", "फळधारणा", "फलन", "కాపు", [52, 260], [0.55, 0.72], "🥥")]
//    },
//    "Coffee": {
//        season: "Perennial", color: "#78350F", ndviPeak: 0.68, note: "Shade grown. Altitude 600-1600m ideal.",
//        stages: [stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [0, 52], [0.45, 0.65], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [52, 60], [0.50, 0.68], "🌸"), stg("Harvest", "काढणी", "कटाई", "కోత", [78, 86], [0.42, 0.58], "🚜")]
//    },
//    "Orange": {
//        season: "Rabi", color: "#F97316", ndviPeak: 0.65, note: "Vidarbha speciality. Stress irrigation for flowering.",
//        stages: [stg("Dormancy", "विश्राम", "सुप्त", "నిద్ర", [0, 6], [0.38, 0.52], "🌳"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 10], [0.40, 0.55], "🌸"), stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు వృద్ధి", [14, 28], [0.50, 0.65], "🍊"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [28, 34], [0.42, 0.58], "🚜")]
//    },
//    "Guava": {
//        season: "Kharif", color: "#86EFAC", ndviPeak: 0.62, note: "Two crops/year. Hardy and drought tolerant.",
//        stages: [stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 2], [0.15, 0.28], "✂️"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.35, 0.55], "🌿"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [16, 20], [0.38, 0.52], "🚜")]
//    },
//    "Lemon": {
//        season: "Perennial", color: "#FEF08A", ndviPeak: 0.62, note: "Year-round fruiting. Needs regular moisture.",
//        stages: [stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [0, 8], [0.38, 0.55], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.42, 0.58], "🌸"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [24, 28], [0.38, 0.52], "🚜")]
//    },
//    "Moringa": {
//        season: "Kharif", color: "#4ADE80", ndviPeak: 0.62, note: "Nutritional powerhouse. Fast growing. Drought hardy.",
//        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.08, 0.22], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 16], [0.35, 0.58], "🌿"), stg("Harvest", "काढणी", "कटाई", "కోత", [16, 52], [0.40, 0.62], "🚜")]
//    },
//    "Aloe Vera": {
//        season: "Kharif", color: "#86EFAC", ndviPeak: 0.48, note: "Medicinal. Very drought tolerant. Sandy soils.",
//        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.10, 0.25], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 20], [0.25, 0.48], "🌿"), stg("Harvest", "काढणी", "कटाई", "కోత", [20, 26], [0.22, 0.42], "🚜")]
//    },
//    "Isabgol": {
//        season: "Rabi", color: "#F9F9F0", ndviPeak: 0.45, note: "Medicinal. Cool dry climate. Low NDVI.",
//        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.18, 0.38], "🌿"), stg("Harvest", "काढणी", "कटाई", "కోత", [9, 11], [0.15, 0.28], "🚜")]
//    },
//    "Ashwagandha": {
//        season: "Kharif", color: "#D97706", ndviPeak: 0.48, note: "Medicinal shrub. Sandy loam soils. 150-180 days.",
//        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 10], [0.22, 0.45], "🌿"), stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [16, 22], [0.18, 0.35], "🚜")]
//    },
//    "Mixed Orchard": {
//        season: "Perennial", color: "#22D3EE", ndviPeak: 0.65, note: "Multiple fruit tree varieties.",
//        stages: [stg("Active", "सक्रिय", "सक्रिय", "చురుకు", [0, 52], [0.45, 0.70], "🌳")]
//    },
//    "Teak": {
//        season: "Perennial", color: "#92400E", ndviPeak: 0.70, note: "Timber crop. 15-20 year rotation.",
//        stages: [stg("Plantation", "लागवड", "रोपण", "నాటడం", [0, 52], [0.20, 0.45], "🌱"), stg("Growing", "वाढ", "वृद्धि", "వృద్ధి", [52, 520], [0.55, 0.72], "🌳")]
//    },
//    "Fallow/Bare": {
//        season: "Kharif", color: "#b8d0e8", ndviPeak: 0.08, note: "No crop. Bare soil or early fallow.",
//        stages: [stg("Bare", "पडीत", "परती", "బీడు", [0, 52], [0.02, 0.12], "🟫")]
//    },
//    // ── KARDAI / SAFFLOWER (Maharashtra specialty oilseed) ────────────
//    "Kardai/Safflower": {
//        season: "Rabi", color: "#FF8C42", ndviPeak: 0.55,
//        note: "Maharashtra #1 Rabi oilseed after Soybean. Drought hardy. 120-140 days.",
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Rosette", mr: "रोझेट अवस्था", hi: "रोसेट", te: "రోసెట్", weeks: [2, 5], ndviRange: [0.15, 0.35], icon: "🌿" },
//            { name: "Branching", mr: "फांदी येणे", hi: "शाखाएं", te: "కొమ్మలు", weeks: [5, 9], ndviRange: [0.32, 0.52], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [9, 12], ndviRange: [0.42, 0.60], icon: "🌸" },
//            { name: "Seed Fill", mr: "बीज भरणे", hi: "बीज भरना", te: "విత్తన నిండటం", weeks: [12, 16], ndviRange: [0.35, 0.52], icon: "🌻" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [16, 20], ndviRange: [0.18, 0.32], icon: "🚜" },
//        ]
//    },
//    "Javas/Linseed": {
//        season: "Rabi", color: "#93C5FD", ndviPeak: 0.52,
//        note: "Linseed known as 'Javas' in Maharashtra. Dual-use: oil + fibre. 100-120 days.",
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.20, 0.42], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 8], ndviRange: [0.40, 0.55], icon: "🌸" },
//            { name: "Capsule", mr: "कॅप्सूल", hi: "कैप्सूल", te: "క్యాప్సూల్", weeks: [8, 11], ndviRange: [0.35, 0.50], icon: "🌻" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [11, 14], ndviRange: [0.15, 0.28], icon: "🚜" },
//        ]
//    },

//    // ── ADDITIONAL CROPS V5.4.0 (farmer requested + Maharashtra specialty) ──

//    "Kardai/Safflower": {
//        season: "Rabi", color: "#FF8C42", ndviPeak: 0.55,
//        note: "Maharashtra #1 Rabi oilseed. 90-110 days. Drought hardy. Spiny varieties.",
//        alertThresholds: { ndvi_stress: 0.22, moisture_low: 25, moisture_high: 70 },
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Rosette", mr: "रोझेट अवस्था", hi: "रोसेट", te: "రోసెట్", weeks: [2, 5], ndviRange: [0.15, 0.38], icon: "🌿" },
//            { name: "Branching", mr: "फांदी येणे", hi: "शाखाएं", te: "కొమ్మలు", weeks: [5, 9], ndviRange: [0.35, 0.55], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [9, 12], ndviRange: [0.42, 0.62], icon: "🌸" },
//            { name: "Seed Fill", mr: "बीज भरणे", hi: "बीज भरना", te: "విత్తన నిండటం", weeks: [12, 16], ndviRange: [0.32, 0.52], icon: "🌻" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [16, 20], ndviRange: [0.15, 0.30], icon: "🚜" },
//        ]
//    },
//    "Ajwain/Carom": {
//        season: "Rabi", color: "#D4A017", ndviPeak: 0.48,
//        note: "Spice crop. Cool dry climate. 120-150 days. Rajasthan & Maharashtra.",
//        alertThresholds: { ndvi_stress: 0.18, moisture_low: 20, moisture_high: 60 },
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 7], ndviRange: [0.20, 0.42], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [7, 10], ndviRange: [0.35, 0.50], icon: "🌸" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [10, 14], ndviRange: [0.18, 0.32], icon: "🚜" },
//        ]
//    },
//    "Jeera/Cumin": {
//        season: "Rabi", color: "#C8B400", ndviPeak: 0.45,
//        note: "Spice crop. Low water. Gujarat & Maharashtra. Very low NDVI — thin leaves.",
//        alertThresholds: { ndvi_stress: 0.15, moisture_low: 18, moisture_high: 55 },
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.18, 0.38], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 9], ndviRange: [0.30, 0.45], icon: "🌸" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [9, 12], ndviRange: [0.15, 0.28], icon: "🚜" },
//        ]
//    },
//    "Dhania/Coriander Seed": {
//        season: "Rabi", color: "#8FBC8F", ndviPeak: 0.48,
//        note: "Seed coriander for spice. Maharashtra, MP. Cool dry climate.",
//        alertThresholds: { ndvi_stress: 0.18, moisture_low: 20, moisture_high: 60 },
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 5], ndviRange: [0.20, 0.42], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [5, 7], ndviRange: [0.35, 0.48], icon: "🌸" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [7, 10], ndviRange: [0.20, 0.35], icon: "🚜" },
//        ]
//    },
//    "Lemongrass": {
//        season: "Kharif", color: "#78C850", ndviPeak: 0.65,
//        note: "Essential oil crop. Perennial. Low maintenance. Drought tolerant.",
//        alertThresholds: { ndvi_stress: 0.25, moisture_low: 22, moisture_high: 65 },
//        stages: [
//            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 4], ndviRange: [0.10, 0.30], icon: "🌱" },
//            { name: "Active", mr: "वाढ", hi: "वृद्धि", te: "వృద్ధి", weeks: [4, 24], ndviRange: [0.45, 0.65], icon: "🌿" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [24, 52], ndviRange: [0.40, 0.60], icon: "🚜" },
//        ]
//    },
//    "Stevia": {
//        season: "Kharif", color: "#90EE90", ndviPeak: 0.58,
//        note: "Zero-calorie sweetener. High-value export crop. Maharashtra growing.",
//        alertThresholds: { ndvi_stress: 0.22, moisture_low: 28, moisture_high: 70 },
//        stages: [
//            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 3], ndviRange: [0.10, 0.28], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [3, 10], ndviRange: [0.35, 0.58], icon: "🌿" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [10, 52], ndviRange: [0.40, 0.58], icon: "🚜" },
//        ]
//    },
//    "Strawberry": {
//        season: "Rabi", color: "#FF6B6B", ndviPeak: 0.60,
//        note: "Mahabaleshwar specialty. Cool climate 15-25°C. High value.",
//        alertThresholds: { ndvi_stress: 0.22, moisture_low: 30, moisture_high: 70 },
//        stages: [
//            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 3], ndviRange: [0.10, 0.28], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [3, 6], ndviRange: [0.30, 0.55], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 9], ndviRange: [0.40, 0.60], icon: "🌸" },
//            { name: "Fruiting", mr: "फळे", hi: "फल", te: "పండు", weeks: [9, 18], ndviRange: [0.42, 0.60], icon: "🍓" },
//            { name: "Harvest", mr: "काढणी", hi: "तुड़ाई", te: "కోత", weeks: [18, 24], ndviRange: [0.35, 0.55], icon: "🚜" },
//        ]
//    },
//    "Fig/Anjeer": {
//        season: "Perennial", color: "#9370DB", ndviPeak: 0.62,
//        note: "Pune/Solapur specialty. Drought hardy. High export value.",
//        alertThresholds: { ndvi_stress: 0.25, moisture_low: 25, moisture_high: 65 },
//        stages: [
//            { name: "Dormancy", mr: "सुप्तावस्था", hi: "सुप्त", te: "నిద్ర", weeks: [0, 4], ndviRange: [0.20, 0.38], icon: "🌳" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [4, 12], ndviRange: [0.40, 0.62], icon: "🌿" },
//            { name: "Fruit", mr: "फळे", hi: "फल", te: "పండు", weeks: [12, 24], ndviRange: [0.42, 0.62], icon: "🫐" },
//        ]
//    },
//    "Drumstick/Moringa": {
//        season: "Kharif", color: "#32CD32", ndviPeak: 0.62,
//        note: "Nutritional powerhouse. Fast growing. Drought hardy. Year-round harvest.",
//        alertThresholds: { ndvi_stress: 0.22, moisture_low: 20, moisture_high: 65 },
//        stages: [
//            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 4], ndviRange: [0.08, 0.25], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [4, 16], ndviRange: [0.35, 0.60], icon: "🌿" },
//            { name: "Pod Harvest", mr: "शेंगा काढणी", hi: "सहजन", te: "మునగ", weeks: [16, 52], ndviRange: [0.40, 0.62], icon: "🚜" },
//        ]
//    },
//    "Beetroot": {
//        season: "Rabi", color: "#DC143C", ndviPeak: 0.55,
//        note: "Root vegetable. Cool climate. High water demand at root development.",
//        alertThresholds: { ndvi_stress: 0.20, moisture_low: 30, moisture_high: 75 },
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.22, 0.48], icon: "🌿" },
//            { name: "Root Dev.", mr: "मुळे भरणे", hi: "जड़ विकास", te: "మూల వృద్ధి", weeks: [6, 10], ndviRange: [0.35, 0.55], icon: "🫀" },
//            { name: "Harvest", mr: "काढणी", hi: "खुदाई", te: "తవ్వడం", weeks: [10, 14], ndviRange: [0.25, 0.42], icon: "🚜" },
//        ]
//    },
//    "Cluster Bean/Guar": {
//        season: "Kharif", color: "#7CFC00", ndviPeak: 0.58,
//        note: "Industrial gum crop + vegetable. Drought tolerant. Maharashtra, Rajasthan.",
//        alertThresholds: { ndvi_stress: 0.20, moisture_low: 18, moisture_high: 60 },
//        stages: [
//            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.28, 0.52], icon: "🌿" },
//            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 8], ndviRange: [0.42, 0.58], icon: "🌸" },
//            { name: "Pod Fill", mr: "शेंगा", hi: "फलियां", te: "శింగాలు", weeks: [8, 12], ndviRange: [0.38, 0.55], icon: "🌻" },
//            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [12, 15], ndviRange: [0.18, 0.35], icon: "🚜" },
//        ]
//    },
//    "Taro/Arbi": {
//        season: "Kharif", color: "#9ACD32", ndviPeak: 0.68,
//        note: "Corm crop. High moisture. Shade tolerant. Kerala, Maharashtra.",
//        alertThresholds: { ndvi_stress: 0.28, moisture_low: 40, moisture_high: 85 },
//        stages: [
//            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 3], ndviRange: [0.10, 0.28], icon: "🌱" },
//            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [3, 16], ndviRange: [0.45, 0.68], icon: "🌿" },
//            { name: "Maturity", mr: "परिपक्वता", hi: "परिपक्वता", te: "పరిపక్వత", weeks: [16, 24], ndviRange: [0.35, 0.55], icon: "🟡" },
//            { name: "Harvest", mr: "काढणी", hi: "खुदाई", te: "తవ్వడం", weeks: [24, 28], ndviRange: [0.18, 0.35], icon: "🚜" },
//        ]
//    },

//    // ── CATCH-ALL ────────────────────────────────────────────────────
//    "Unknown": {
//        season: "—", color: "#b8d0e8", ndviPeak: 0.50,
//        note: "Crop not identified. Run scan for detection.",
//        stages: []
//    },
//};

//// ── CROP_YIELD_PARAMS ────────────────────────────────────────────
//// Source: Maharashtra Agriculture Dept + ICAR benchmarks
//// {season_base_kg_ha, ndvi_ref, harvest_index, rue g_C/MJ}
//export const CROP_YIELD_PARAMS = {
//    "Rice": { Kharif: 2500, Rabi: 2200, Zaid: 2000, ndvi_ref: 0.65, hi: 0.50, rue: 1.8 },
//    "Wheat": { Kharif: 2500, Rabi: 3000, Zaid: 2200, ndvi_ref: 0.68, hi: 0.48, rue: 2.0 },
//    "Maize/Corn": { Kharif: 3500, Rabi: 3200, Zaid: 3000, ndvi_ref: 0.72, hi: 0.50, rue: 2.2 },
//    "Jowar/Sorghum": { Kharif: 1800, Rabi: 1600, Zaid: 1400, ndvi_ref: 0.62, hi: 0.42, rue: 1.6 },
//    "Bajra/Millet": { Kharif: 1500, Rabi: 1400, Zaid: 1200, ndvi_ref: 0.58, hi: 0.40, rue: 1.5 },
//    "Ragi/Finger Millet": { Kharif: 1400, Rabi: 1300, Zaid: 1100, ndvi_ref: 0.55, hi: 0.38, rue: 1.4 },
//    "Barley": { Kharif: 2000, Rabi: 2500, Zaid: 1800, ndvi_ref: 0.60, hi: 0.45, rue: 1.8 },
//    "Sugarcane": { Kharif: 70000, Rabi: 75000, Zaid: 65000, ndvi_ref: 0.78, hi: 0.90, rue: 3.0 },
//    "Cotton": { Kharif: 500, Rabi: 500, Zaid: 450, ndvi_ref: 0.60, hi: 0.40, rue: 1.5 },
//    "Soybean": { Kharif: 1200, Rabi: 1000, Zaid: 900, ndvi_ref: 0.65, hi: 0.45, rue: 1.6 },
//    "Groundnut": { Kharif: 1500, Rabi: 1400, Zaid: 1200, ndvi_ref: 0.62, hi: 0.42, rue: 1.5 },
//    "Sunflower": { Kharif: 1200, Rabi: 1100, Zaid: 1000, ndvi_ref: 0.65, hi: 0.40, rue: 1.6 },
//    "Mustard/Rapeseed": { Kharif: 900, Rabi: 1200, Zaid: 800, ndvi_ref: 0.58, hi: 0.38, rue: 1.4 },
//    "Sesame/Til": { Kharif: 600, Rabi: 550, Zaid: 500, ndvi_ref: 0.52, hi: 0.35, rue: 1.2 },
//    "Castor": { Kharif: 1200, Rabi: 1100, Zaid: 900, ndvi_ref: 0.60, hi: 0.42, rue: 1.5 },
//    "Linseed/Flax": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.52, hi: 0.38, rue: 1.3 },
//    "Gram/Chickpea": { Kharif: 900, Rabi: 1100, Zaid: 800, ndvi_ref: 0.42, hi: 0.40, rue: 1.2 },
//    "Tur/Pigeon Pea": { Kharif: 1200, Rabi: 1000, Zaid: 900, ndvi_ref: 0.55, hi: 0.38, rue: 1.3 },
//    "Moong/Green Gram": { Kharif: 700, Rabi: 650, Zaid: 600, ndvi_ref: 0.48, hi: 0.35, rue: 1.1 },
//    "Udid/Black Gram": { Kharif: 650, Rabi: 600, Zaid: 550, ndvi_ref: 0.45, hi: 0.35, rue: 1.1 },
//    "Masoor/Lentil": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.44, hi: 0.36, rue: 1.2 },
//    "Rajma/Kidney Bean": { Kharif: 1000, Rabi: 900, Zaid: 850, ndvi_ref: 0.58, hi: 0.38, rue: 1.3 },
//    "Cowpea": { Kharif: 800, Rabi: 750, Zaid: 700, ndvi_ref: 0.52, hi: 0.36, rue: 1.2 },
//    "Onion": { Kharif: 20000, Rabi: 25000, Zaid: 18000, ndvi_ref: 0.30, hi: 0.80, rue: 2.5 },
//    "Tomato": { Kharif: 25000, Rabi: 30000, Zaid: 22000, ndvi_ref: 0.62, hi: 0.70, rue: 2.2 },
//    "Chilli": { Kharif: 8000, Rabi: 8500, Zaid: 7000, ndvi_ref: 0.58, hi: 0.65, rue: 1.8 },
//    "Brinjal/Eggplant": { Kharif: 18000, Rabi: 20000, Zaid: 16000, ndvi_ref: 0.62, hi: 0.70, rue: 2.0 },
//    "Bhendi/Okra": { Kharif: 7000, Rabi: 7500, Zaid: 6000, ndvi_ref: 0.55, hi: 0.65, rue: 1.7 },
//    "Cauliflower": { Kharif: 12000, Rabi: 15000, Zaid: 10000, ndvi_ref: 0.55, hi: 0.72, rue: 1.8 },
//    "Cabbage": { Kharif: 15000, Rabi: 18000, Zaid: 12000, ndvi_ref: 0.60, hi: 0.75, rue: 1.9 },
//    "Carrot": { Kharif: 15000, Rabi: 18000, Zaid: 12000, ndvi_ref: 0.52, hi: 0.72, rue: 1.7 },
//    "Radish/Mula": { Kharif: 12000, Rabi: 15000, Zaid: 10000, ndvi_ref: 0.48, hi: 0.75, rue: 1.6 },
//    "Garlic": { Kharif: 7000, Rabi: 8000, Zaid: 6000, ndvi_ref: 0.38, hi: 0.78, rue: 1.5 },
//    "Potato": { Kharif: 18000, Rabi: 22000, Zaid: 16000, ndvi_ref: 0.68, hi: 0.75, rue: 2.2 },
//    "Methi/Fenugreek": { Kharif: 1000, Rabi: 1200, Zaid: 900, ndvi_ref: 0.48, hi: 0.60, rue: 1.3 },
//    "Bitter Gourd": { Kharif: 8000, Rabi: 8500, Zaid: 7000, ndvi_ref: 0.58, hi: 0.65, rue: 1.7 },
//    "Pumpkin": { Kharif: 12000, Rabi: 14000, Zaid: 10000, ndvi_ref: 0.62, hi: 0.70, rue: 1.8 },
//    "Lauki/Bottle Gourd": { Kharif: 10000, Rabi: 12000, Zaid: 8000, ndvi_ref: 0.58, hi: 0.68, rue: 1.7 },
//    "Turmeric": { Kharif: 15000, Rabi: 14000, Zaid: 12000, ndvi_ref: 0.68, hi: 0.85, rue: 2.0 },
//    "Ginger": { Kharif: 18000, Rabi: 16000, Zaid: 14000, ndvi_ref: 0.65, hi: 0.82, rue: 1.9 },
//    "Banana": { Kharif: 35000, Rabi: 32000, Zaid: 30000, ndvi_ref: 0.70, hi: 0.88, rue: 2.8 },
//    "Mango": { Kharif: 8000, Rabi: 10000, Zaid: 7000, ndvi_ref: 0.65, hi: 0.85, rue: 2.0 },
//    "Grape": { Kharif: 15000, Rabi: 18000, Zaid: 14000, ndvi_ref: 0.60, hi: 0.88, rue: 2.2 },
//    "Pomegranate": { Kharif: 12000, Rabi: 14000, Zaid: 10000, ndvi_ref: 0.55, hi: 0.85, rue: 1.9 },
//    "Papaya": { Kharif: 35000, Rabi: 32000, Zaid: 28000, ndvi_ref: 0.62, hi: 0.86, rue: 2.5 },
//    "Orange/Sweet Lime": { Kharif: 10000, Rabi: 12000, Zaid: 9000, ndvi_ref: 0.62, hi: 0.82, rue: 2.0 },
//    "Guava": { Kharif: 12000, Rabi: 14000, Zaid: 10000, ndvi_ref: 0.60, hi: 0.82, rue: 1.9 },
//    "Sugarcane": { Kharif: 70000, Rabi: 75000, Zaid: 65000, ndvi_ref: 0.78, hi: 0.90, rue: 3.0 },
//    "Tobacco": { Kharif: 1800, Rabi: 2000, Zaid: 1600, ndvi_ref: 0.62, hi: 0.72, rue: 1.7 },
//    "Jute": { Kharif: 2000, Rabi: 1800, Zaid: 1600, ndvi_ref: 0.70, hi: 0.80, rue: 2.0 },
//    "Castor": { Kharif: 1200, Rabi: 1100, Zaid: 900, ndvi_ref: 0.60, hi: 0.42, rue: 1.5 },
//    "Spinach": { Kharif: 8000, Rabi: 10000, Zaid: 7000, ndvi_ref: 0.55, hi: 0.80, rue: 1.6 },
//    "Coriander": { Kharif: 700, Rabi: 900, Zaid: 600, ndvi_ref: 0.45, hi: 0.65, rue: 1.2 },
//    "Kardai/Safflower": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.52, hi: 0.36, rue: 1.3 },
//    "Javas/Linseed": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.50, hi: 0.36, rue: 1.3 },
//    "Kardai/Safflower": { Kharif: 700, Rabi: 900, Zaid: 600, ndvi_ref: 0.52, hi: 0.36, rue: 1.3 },
//    "Ajwain/Carom": { Kharif: 600, Rabi: 800, Zaid: 500, ndvi_ref: 0.45, hi: 0.60, rue: 1.2 },
//    "Jeera/Cumin": { Kharif: 500, Rabi: 700, Zaid: 450, ndvi_ref: 0.42, hi: 0.60, rue: 1.2 },
//    "Dhania/Coriander Seed": { Kharif: 600, Rabi: 800, Zaid: 500, ndvi_ref: 0.45, hi: 0.65, rue: 1.2 },
//    "Lemongrass": { Kharif: 15000, Rabi: 14000, Zaid: 12000, ndvi_ref: 0.60, hi: 0.80, rue: 1.6 },
//    "Stevia": { Kharif: 8000, Rabi: 8000, Zaid: 7000, ndvi_ref: 0.55, hi: 0.75, rue: 1.5 },
//    "Strawberry": { Kharif: 12000, Rabi: 15000, Zaid: 10000, ndvi_ref: 0.58, hi: 0.82, rue: 1.8 },
//    "Fig/Anjeer": { Kharif: 10000, Rabi: 12000, Zaid: 9000, ndvi_ref: 0.60, hi: 0.84, rue: 1.8 },
//    "Drumstick/Moringa": { Kharif: 18000, Rabi: 16000, Zaid: 14000, ndvi_ref: 0.60, hi: 0.82, rue: 1.9 },
//    "Beetroot": { Kharif: 20000, Rabi: 25000, Zaid: 18000, ndvi_ref: 0.52, hi: 0.78, rue: 1.7 },
//    "Cluster Bean/Guar": { Kharif: 1000, Rabi: 900, Zaid: 800, ndvi_ref: 0.55, hi: 0.40, rue: 1.3 },
//    "Taro/Arbi": { Kharif: 18000, Rabi: 16000, Zaid: 14000, ndvi_ref: 0.65, hi: 0.82, rue: 2.0 },
//    "Unknown": { Kharif: 1500, Rabi: 1500, Zaid: 1200, ndvi_ref: 0.50, hi: 0.45, rue: 1.5 },
//};

//// ── Crop display name in 4 languages ────────────────────────────
//export const CROP_NAMES_L10N = {
//    "Rice": { mr: "भात", hi: "चावल", te: "వరి" },
//    "Wheat": { mr: "गहू", hi: "गेहूं", te: "గోధుమ" },
//    "Maize/Corn": { mr: "मका", hi: "मक्का", te: "మొక్కజొన్న" },
//    "Jowar/Sorghum": { mr: "ज्वारी", hi: "ज्वार", te: "జొన్న" },
//    "Bajra/Millet": { mr: "बाजरा", hi: "बाजरा", te: "సజ్జ" },
//    "Sugarcane": { mr: "ऊस", hi: "गन्ना", te: "చెరకు" },
//    "Cotton": { mr: "कापूस", hi: "कपास", te: "పత్తి" },
//    "Soybean": { mr: "सोयाबीन", hi: "सोयाबीन", te: "సోయాబీన్" },
//    "Groundnut": { mr: "भुईमूग", hi: "मूंगफली", te: "వేరుశనగ" },
//    "Onion": { mr: "कांदा", hi: "प्याज", te: "ఉల్లి" },
//    "Tomato": { mr: "टोमॅटो", hi: "टमाटर", te: "టొమాటో" },
//    "Chilli": { mr: "मिरची", hi: "मिर्च", te: "మిరప" },
//    "Turmeric": { mr: "हळद", hi: "हल्दी", te: "పసుపు" },
//    "Ginger": { mr: "आले", hi: "अदरक", te: "అల్లం" },
//    "Gram/Chickpea": { mr: "हरभरा", hi: "चना", te: "శనగ" },
//    "Tur/Pigeon Pea": { mr: "तूर", hi: "अरहर", te: "కంది" },
//    "Banana": { mr: "केळ", hi: "केला", te: "అరటి" },
//    "Mango": { mr: "आंबा", hi: "आम", te: "మామిడి" },
//    "Grape": { mr: "द्राक्षा", hi: "अंगूर", te: "ద్రాక్ష" },
//    "Pomegranate": { mr: "डाळिंब", hi: "अनार", te: "దానిమ్మ" },
//    "Papaya": { mr: "पपई", hi: "पपीता", te: "బొప్పాయి" },
//    "Potato": { mr: "बटाटा", hi: "आलू", te: "బంగాళాదుంప" },
//    "Mustard/Rapeseed": { mr: "मोहरी", hi: "सरसों", te: "ఆవాలు" },
//    "Sunflower": { mr: "सूर्यफूल", hi: "सूरजमुखी", te: "పొద్దుతిరుగుడు" },
//    "Kardai/Safflower": { mr: "कर्डई", hi: "कुसुम", te: "కుసుమ" },
//    "Javas/Linseed": { mr: "जवस", hi: "अलसी", te: "అవిసె" },
//    // Farmer-friendly Marathi names for existing crops (aliases)
//    "Sesame/Til": { mr: "तीळ", hi: "तिल", te: "నువ్వులు" },
//    "Moong/Green Gram": { mr: "मूग", hi: "मूंग", te: "పెసలు" },
//    "Udid/Black Gram": { mr: "उडीद", hi: "उड़द", te: "మినుములు" },
//    "Gram/Chickpea": { mr: "हरभरा", hi: "चना", te: "శనగ" },
//    "Cowpea": { mr: "चवळी", hi: "लोबिया", te: "అలసంద" },
//    "Rajma/Kidney Bean": { mr: "राजमा", hi: "राजमा", te: "రాజ్మా" },
//    "Tur/Pigeon Pea": { mr: "तूर", hi: "अरहर", te: "కంది" },
//    "Linseed/Flax": { mr: "जवस", hi: "अलसी", te: "అవిసె" },
//    "Mustard/Rapeseed": { mr: "मोहरी", hi: "सरसों", te: "ఆవాలు" },
//    "Kardai/Safflower": { mr: "कर्डई", hi: "कुसुम", te: "కుసుమ" },
//    "Ajwain/Carom": { mr: "ओवा", hi: "अजवाइन", te: "వాము" },
//    "Jeera/Cumin": { mr: "जिरे", hi: "जीरा", te: "జీలకర్ర" },
//    "Dhania/Coriander Seed": { mr: "धणे", hi: "धनिया", te: "ధనియాలు" },
//    "Lemongrass": { mr: "लिंबुगवत", hi: "नींबू घास", te: "నిమ్మ గడ్డి" },
//    "Stevia": { mr: "स्टेव्हिया", hi: "स्टेविया", te: "స్టీవియా" },
//    "Strawberry": { mr: "स्ट्रॉबेरी", hi: "स्ट्रॉबेरी", te: "స్ట్రాబెర్రీ" },
//    "Fig/Anjeer": { mr: "अंजीर", hi: "अंजीर", te: "అత్తి" },
//    "Drumstick/Moringa": { mr: "शेवगा", hi: "सहजन", te: "మునగ" },
//    "Beetroot": { mr: "बीट", hi: "चुकंदर", te: "దుంప" },
//    "Cluster Bean/Guar": { mr: "ग्वार", hi: "ग्वार", te: "గోరుచిక్కుడు" },
//    "Taro/Arbi": { mr: "अळू", hi: "अरबी", te: "చేమదుంప" },
//    // Farmer Marathi aliases for existing crops
//    "Sesame/Til": { mr: "तीळ", hi: "तिल", te: "నువ్వులు" },
//    "Linseed/Flax": { mr: "जवस", hi: "अलसी", te: "అవిసె" },
//    "Rajma/Kidney Bean": { mr: "राजमा", hi: "राजमा", te: "రాజ్మా" },
//    "Moong/Green Gram": { mr: "मूग", hi: "मूंग", te: "పెసలు" },
//    "Mustard/Rapeseed": { mr: "मोहरी", hi: "सरसों", te: "ఆవాలు" },
//    "Udid/Black Gram": { mr: "उडीद", hi: "उड़द", te: "మినుములు" },
//    "Gram/Chickpea": { mr: "हरभरा", hi: "चना", te: "శనగ" },
//    "Cowpea": { mr: "चवळी", hi: "लोबिया", te: "అలసంద" },
//};

//// ── Helper: get localised crop name ─────────────────────────────
//export const getCropName = (key, lang) => {
//    const entry = CROP_NAMES_L10N[key];
//    if (!entry) return key;
//    return entry[lang] || key;
//};

//// ── List of all crop keys (for dropdowns / searches) ────────────
//export const CROP_KEYS = Object.keys(CROP_CALENDAR).filter(k => k !== 'Unknown');


// ═══════════════════════════════════════════════════════════════════
//  CropData.js  —  Bhuhit Agri Intelligence
//  Separate component: Crop Calendar + Yield Params + Spectral Hints
//  75 Maharashtra crops — Kharif / Rabi / Zaid / Perennial
//  Accuracy sources: ICAR, MAHA Agriculture Dept, NDDB
// ═══════════════════════════════════════════════════════════════════

// ── Stage template helpers ───────────────────────────────────────
const stg = (name, mr, hi, te, weeks, ndvi, icon) =>
    ({ name, mr, hi, te, weeks, ndviRange: ndvi, icon });

// ── CROP_CALENDAR ────────────────────────────────────────────────
// Each crop:
//   season  : Kharif | Rabi | Zaid | Perennial
//   color   : dashboard accent hex
//   stages  : array of growth stages with NDVI ranges
//   ndviPeak: expected peak NDVI (for health scoring)
//   note    : brief agronomic note
export const CROP_CALENDAR = {

    // ── CEREALS ─────────────────────────────────────────────────────
    "Rice": {
        season: "Kharif", color: "#39FF14", ndviPeak: 0.72,
        note: "Flood-tolerant. LSWI high at transplanting.",
        stages: [
            stg("Land Prep", "जमीन तयारी", "भूमि तैयारी", "నేల తయారీ", [0, 2], [0.05, 0.18], "🌱"),
            stg("Transplanting", "रोप लावणी", "रोपाई", "నాట్లు వేయడం", [2, 4], [0.10, 0.28], "🌿"),
            stg("Tillering", "फुटवे अवस्था", "कल्ले निकलना", "తనులు వేయడం", [4, 8], [0.25, 0.58], "🌾"),
            stg("Panicle Init.", "लोंबी निर्मिती", "बाली निकलना", "పానికిల్", [8, 12], [0.55, 0.78], "🌾"),
            stg("Heading", "लोंबी बाहेर", "शीर्ष", "హెడింగ్", [12, 16], [0.62, 0.85], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [16, 20], [0.45, 0.72], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [20, 24], [0.15, 0.45], "🚜"),
        ]
    },
    "Wheat": {
        season: "Rabi", color: "#FFB800", ndviPeak: 0.70,
        note: "Winter crop. Cool nights boost grain protein.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Germination", "उगवण", "अंकुरण", "అంకురోద్గమం", [2, 4], [0.10, 0.20], "🌿"),
            stg("Tillering", "फुटवे", "कल्ले", "తనులు", [4, 8], [0.25, 0.45], "🌾"),
            stg("Jointing", "जोडणी", "जोड़", "జాయింటింగ్", [8, 12], [0.45, 0.65], "🌾"),
            stg("Heading", "शीर्ष", "शीर्ष", "హెడింగ్", [12, 14], [0.65, 0.78], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [14, 18], [0.55, 0.70], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 22], [0.20, 0.35], "🚜"),
        ]
    },
    "Maize/Corn": {
        season: "Kharif", color: "#FB923C", ndviPeak: 0.78,
        note: "High water demand at tasseling. Watch for fall armyworm.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.25], "🌿"),
            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.40, 0.65], "🌽"),
            stg("Tasseling", "तुरा येणे", "बाल निकलना", "పుప్పొడి", [8, 10], [0.65, 0.82], "🌾"),
            stg("Silking", "रेशीम येणे", "सिल्किंग", "సిల్కింగ్", [10, 12], [0.68, 0.82], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [12, 16], [0.55, 0.70], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [16, 20], [0.20, 0.40], "🚜"),
        ]
    },
    "Jowar/Sorghum": {
        season: "Kharif", color: "#C2410C", ndviPeak: 0.70,
        note: "Drought tolerant. Dual-purpose: grain + fodder.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 3], [0.10, 0.22], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 7], [0.35, 0.60], "🌿"),
            stg("Booting", "खोड फुगणे", "बूटिंग", "బూటింగ్", [7, 9], [0.55, 0.72], "🌾"),
            stg("Heading", "शीर्ष", "शीर्ष", "హెడింగ్", [9, 11], [0.60, 0.75], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [11, 14], [0.45, 0.65], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [14, 18], [0.18, 0.38], "🚜"),
        ]
    },
    "Bajra/Millet": {
        season: "Kharif", color: "#D97706", ndviPeak: 0.65,
        note: "Sandy soil tolerant. Very drought hardy.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [1, 2], [0.10, 0.20], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.30, 0.55], "🌿"),
            stg("Earhead", "कणीस", "सिट्टा", "ఈలు", [6, 8], [0.50, 0.68], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [8, 11], [0.40, 0.60], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [11, 14], [0.15, 0.32], "🚜"),
        ]
    },
    "Ragi/Finger Millet": {
        season: "Kharif", color: "#92400E", ndviPeak: 0.62,
        note: "High calcium. Suitable for dry regions.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 5], [0.25, 0.50], "🌿"),
            stg("Earhead", "कणीस", "सिट्टा", "ఈలు", [5, 7], [0.45, 0.62], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [7, 10], [0.35, 0.55], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [10, 13], [0.15, 0.30], "🚜"),
        ]
    },
    "Barley": {
        season: "Rabi", color: "#A3E635", ndviPeak: 0.65,
        note: "Tolerates saline soils better than wheat.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Tillering", "फुटवे", "कल्ले", "తనులు", [2, 6], [0.20, 0.45], "🌾"),
            stg("Heading", "शीर्ष", "शीर्ष", "హెడింగ్", [6, 9], [0.55, 0.70], "🌾"),
            stg("Grain Fill", "धान्य भरणे", "दाना भरना", "గింజ నిండటం", [9, 13], [0.45, 0.62], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [13, 16], [0.18, 0.32], "🚜"),
        ]
    },

    // ── OILSEEDS ─────────────────────────────────────────────────────
    "Soybean": {
        season: "Kharif", color: "#A78BFA", ndviPeak: 0.68,
        note: "Fixes nitrogen. Critical water at R3-R6 stages.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.25], "🌿"),
            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.35, 0.60], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 10], [0.55, 0.70], "🌸"),
            stg("Pod Fill", "शेंगा भरणे", "फलियां भरना", "శింగాలు నిండటం", [10, 14], [0.55, 0.70], "🌻"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [14, 16], [0.35, 0.55], "🟡"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [16, 18], [0.15, 0.30], "🚜"),
        ]
    },
    "Groundnut": {
        season: "Kharif", color: "#D97706", ndviPeak: 0.65,
        note: "Calcium critical at pegging. Avoid waterlogging.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.22], "🌿"),
            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 11], [0.50, 0.65], "🌸"),
            stg("Pegging", "पेग निर्मिती", "पेगिंग", "పెగ్గింగ్", [11, 14], [0.55, 0.68], "🥜"),
            stg("Pod Dev.", "शेंगा विकास", "फलियां भरना", "శింగాలు", [14, 18], [0.48, 0.62], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 22], [0.20, 0.35], "🚜"),
        ]
    },
    "Sunflower": {
        season: "Kharif", color: "#FBBF24", ndviPeak: 0.68,
        note: "Heliotropic. Deep taproot tolerates moderate drought.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.12, 0.25], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.35, 0.58], "🌿"),
            stg("Bud Stage", "कळी", "कली", "మొగ్గ", [8, 10], [0.55, 0.68], "🌸"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 13], [0.62, 0.75], "🌻"),
            stg("Seed Fill", "बीज भरणे", "बीज भरना", "విత్తన నిండటం", [13, 17], [0.40, 0.60], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [17, 21], [0.18, 0.35], "🚜"),
        ]
    },
    "Mustard/Rapeseed": {
        season: "Rabi", color: "#FEF08A", ndviPeak: 0.60,
        note: "Quick crop 90-110 days. Sensitive to frost at flowering.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 5], [0.25, 0.45], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 8], [0.45, 0.62], "🌸"),
            stg("Pod Fill", "शेंगा भरणे", "फलियां भरना", "శింగాలు", [8, 11], [0.40, 0.58], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [11, 14], [0.18, 0.30], "🚜"),
        ]
    },
    "Sesame/Til": {
        season: "Kharif", color: "#FDE68A", ndviPeak: 0.58,
        note: "Drought tolerant. Avoid waterlogged soils.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 5], [0.22, 0.45], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.40, 0.58], "🌸"),
            stg("Capsule", "कॅप्सूल", "कैप्सूल", "క్యాప్సూల్", [7, 10], [0.35, 0.52], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [10, 12], [0.15, 0.28], "🚜"),
        ]
    },
    "Linseed/Flax": {
        season: "Rabi", color: "#BFDBFE", ndviPeak: 0.55,
        note: "Dual-use: oil seed and fibre. Cool season crop.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.20, 0.42], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 8], [0.40, 0.55], "🌸"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [8, 11], [0.18, 0.30], "🚜"),
        ]
    },
    "Castor": {
        season: "Kharif", color: "#7C3AED", ndviPeak: 0.65,
        note: "Industrial crop. Deep roots. Grows in marginal land.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"),
            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [2, 8], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.50, 0.65], "🌸"),
            stg("Capsule", "कॅप्सूल", "कैप्सूल", "క్యాప్సూల్", [12, 18], [0.40, 0.60], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 24], [0.22, 0.38], "🚜"),
        ]
    },

    // ── PULSES ───────────────────────────────────────────────────────
    "Gram/Chickpea": {
        season: "Rabi", color: "#FACC15", ndviPeak: 0.45,
        note: "Nitrogen fixing. Susceptible to pod borer at flowering.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [2, 4], [0.10, 0.20], "🌿"),
            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [4, 8], [0.20, 0.38], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 10], [0.35, 0.48], "🌸"),
            stg("Pod Dev.", "शेंगा विकास", "फलियां भरना", "శింగాలు", [10, 14], [0.38, 0.48], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [14, 18], [0.15, 0.30], "🚜"),
        ]
    },
    "Tur/Pigeon Pea": {
        season: "Kharif", color: "#86EFAC", ndviPeak: 0.60,
        note: "Long duration 150-180 days. Deep rooted perennial shrub.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 10], [0.25, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 14], [0.45, 0.62], "🌸"),
            stg("Pod Fill", "शेंगा भरणे", "फलियां भरना", "శింగాలు", [14, 18], [0.40, 0.58], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [18, 22], [0.20, 0.35], "🚜"),
        ]
    },
    "Moong/Green Gram": {
        season: "Kharif", color: "#4ADE80", ndviPeak: 0.55,
        note: "Short duration 60-70 days. Good for intercropping.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.20, 0.45], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.42, 0.55], "🌸"),
            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [6, 9], [0.38, 0.52], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [9, 11], [0.15, 0.28], "🚜"),
        ]
    },
    "Udid/Black Gram": {
        season: "Kharif", color: "#374151", ndviPeak: 0.52,
        note: "Short 65-80 days. Important dal crop. Avoid excess moisture.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.18, 0.42], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.38, 0.52], "🌸"),
            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [6, 9], [0.32, 0.48], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [9, 11], [0.12, 0.25], "🚜"),
        ]
    },
    "Masoor/Lentil": {
        season: "Rabi", color: "#F87171", ndviPeak: 0.48,
        note: "Cold tolerant. Low water requirement.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.18, 0.38], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 8], [0.35, 0.48], "🌸"),
            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [8, 12], [0.30, 0.45], "🌻"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [12, 15], [0.12, 0.25], "🚜"),
        ]
    },
    "Rajma/Kidney Bean": {
        season: "Kharif", color: "#BE123C", ndviPeak: 0.62,
        note: "Cool highland variety. Sensitive to high temperatures.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.28, 0.50], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 9], [0.45, 0.62], "🌸"),
            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [9, 13], [0.42, 0.58], "🫘"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [13, 16], [0.18, 0.32], "🚜"),
        ]
    },

    // ── CASH CROPS ───────────────────────────────────────────────────
    "Cotton": {
        season: "Kharif", color: "#38BDF8", ndviPeak: 0.65,
        note: "Bt cotton predominant. Watch pink bollworm.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 3], [0.05, 0.20], "🌱"),
            stg("Seedling", "रोपण", "पौध", "మొలకలు", [3, 6], [0.15, 0.30], "🌿"),
            stg("Squaring", "कळी येणे", "कली बनना", "మొగ్గ రావడం", [6, 10], [0.35, 0.55], "🌸"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 14], [0.50, 0.70], "🌸"),
            stg("Boll Dev.", "बोंड विकास", "टिण्डा विकास", "బొబ్బ విస్తరణ", [14, 20], [0.55, 0.72], "🔵"),
            stg("Boll Opening", "बोंड उघडणे", "टिण्डा खुलना", "బొబ్బ తెరవడం", [20, 26], [0.30, 0.50], "☁️"),
            stg("Harvest", "वेचणी", "चुनाई", "సేకరణ", [26, 32], [0.15, 0.30], "🚜"),
        ]
    },
    "Sugarcane": {
        season: "Kharif", color: "#22C55E", ndviPeak: 0.80,
        note: "Long duration 10-18 months. Highest water user.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.10, 0.25], "🌱"),
            stg("Germination", "उगवण", "अंकुरण", "అంకురం", [4, 8], [0.20, 0.40], "🌿"),
            stg("Tillering", "फुटवे", "कल्ले", "తనులు", [8, 16], [0.40, 0.65], "🌿"),
            stg("Grand Growth", "मोठी वाढ", "ग्रांड ग्रोथ", "పెద్ద వృద్ధి", [16, 32], [0.65, 0.85], "🌿"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [32, 44], [0.55, 0.75], "🟡"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [44, 52], [0.35, 0.55], "🚜"),
        ]
    },
    "Turmeric": {
        season: "Kharif", color: "#EAB308", ndviPeak: 0.72,
        note: "Shade tolerant. 7-9 months. Rhizome crop.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.20], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 6], [0.20, 0.40], "🌿"),
            stg("Vegetative", "वनस्पतीजन्य", "वानस्पतिक", "వృక్ష దశ", [6, 14], [0.45, 0.70], "🌿"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [14, 28], [0.55, 0.75], "🟡"),
            stg("Senescence", "पर्णपात", "पत्तों का झड़ना", "ఆకు రాలడం", [28, 36], [0.30, 0.50], "🍂"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [36, 40], [0.10, 0.25], "🚜"),
        ]
    },
    "Ginger": {
        season: "Kharif", color: "#CA8A04", ndviPeak: 0.68,
        note: "Shade beneficial. High humidity requirement.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.18], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 5], [0.18, 0.35], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 14], [0.40, 0.68], "🌿"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [14, 22], [0.30, 0.50], "🟡"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [22, 26], [0.12, 0.28], "🚜"),
        ]
    },
    "Tobacco": {
        season: "Rabi", color: "#78716C", ndviPeak: 0.65,
        note: "Requires specific curing. Sensitive to soil pH.",
        stages: [
            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 4], [0.08, 0.22], "🌱"),
            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [4, 6], [0.20, 0.38], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [6, 12], [0.45, 0.65], "🌿"),
            stg("Topping", "शेंडा खुडणे", "टॉपिंग", "టాపింగ్", [12, 14], [0.55, 0.68], "✂️"),
            stg("Harvest", "कापणी", "तुड़ाई", "కోత", [14, 18], [0.35, 0.55], "🚜"),
        ]
    },
    "Jute": {
        season: "Kharif", color: "#A16207", ndviPeak: 0.75,
        note: "Fibre crop. High rainfall requirement. Grows fast.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 10], [0.40, 0.72], "🌿"),
            stg("Harvest", "कापणी", "कटाई", "కోత", [10, 14], [0.35, 0.60], "🚜"),
        ]
    },

    // ── VEGETABLES ───────────────────────────────────────────────────
    "Onion": {
        season: "Rabi", color: "#F97316", ndviPeak: 0.32,
        note: "Very low NDVI — narrow leaves. Bolting risk in warm weather.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 3], [0.05, 0.15], "🌱"),
            stg("Seedling", "रोपण", "पौध", "మొలకలు", [3, 6], [0.10, 0.22], "🌿"),
            stg("Bulb Init.", "कांदा सुरू", "बल्ब शुरू", "బల్బ్ ఆరంభం", [6, 12], [0.18, 0.32], "🧅"),
            stg("Bulb Growth", "कांदा वाढ", "बल्ब बड़ा", "బల్బ్ వృద్ధి", [12, 18], [0.22, 0.38], "🧅"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [18, 22], [0.15, 0.28], "🟡"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [22, 26], [0.10, 0.20], "🚜"),
        ]
    },
    "Tomato": {
        season: "Kharif", color: "#EF4444", ndviPeak: 0.65,
        note: "High value. Temperature sensitive at fruit set.",
        stages: [
            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [3, 5], [0.15, 0.30], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [9, 12], [0.45, 0.65], "🌸"),
            stg("Fruit Set", "फळ बांधणी", "फल बंधन", "పండు", [12, 15], [0.50, 0.70], "🍅"),
            stg("Ripening", "पिकणे", "पकना", "పండు పక్వం", [15, 18], [0.35, 0.55], "🍅"),
            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [18, 22], [0.25, 0.45], "🚜"),
        ]
    },
    "Chilli": {
        season: "Kharif", color: "#DC2626", ndviPeak: 0.60,
        note: "Long season 180+ days. Thrips and mites common.",
        stages: [
            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 4], [0.05, 0.18], "🌱"),
            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [4, 6], [0.15, 0.30], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [6, 10], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 14], [0.45, 0.62], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [14, 18], [0.45, 0.60], "🌶️"),
            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [18, 26], [0.35, 0.55], "🚜"),
        ]
    },
    "Brinjal/Eggplant": {
        season: "Kharif", color: "#7C3AED", ndviPeak: 0.65,
        note: "Long harvest period. Shoot and fruit borer vigilance.",
        stages: [
            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
            stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [3, 5], [0.15, 0.28], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [9, 12], [0.45, 0.65], "🌸"),
            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [12, 30], [0.40, 0.62], "🚜"),
        ]
    },
    "Bhendi/Okra": {
        season: "Kharif", color: "#65A30D", ndviPeak: 0.60,
        note: "Fast growing. 55-60 days to first harvest.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.25, 0.50], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.45, 0.62], "🌸"),
            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [6, 14], [0.42, 0.60], "🚜"),
        ]
    },
    "Cauliflower": {
        season: "Rabi", color: "#F8FAFC", ndviPeak: 0.58,
        note: "Cool weather essential for curd formation.",
        stages: [
            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.28, 0.50], "🌿"),
            stg("Curd Form.", "फूल बनणे", "फूलगोभी", "గొబ్బెర", [8, 12], [0.38, 0.58], "🥦"),
            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [12, 16], [0.32, 0.50], "🚜"),
        ]
    },
    "Cabbage": {
        season: "Rabi", color: "#86EFAC", ndviPeak: 0.62,
        note: "Heavy feeder. Tip burn in high temperatures.",
        stages: [
            stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 3], [0.05, 0.18], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.30, 0.55], "🌿"),
            stg("Heading", "डोके बनणे", "हेडिंग", "హెడింగ్", [8, 12], [0.42, 0.62], "🥬"),
            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [12, 15], [0.35, 0.52], "🚜"),
        ]
    },
    "Carrot": {
        season: "Rabi", color: "#F97316", ndviPeak: 0.55,
        note: "Root crop. Loose deep soil preferred.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 7], [0.22, 0.45], "🌿"),
            stg("Root Dev.", "मूळ विकास", "जड़ विकास", "మూల వృద్ధి", [7, 12], [0.30, 0.52], "🥕"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [12, 15], [0.25, 0.42], "🚜"),
        ]
    },
    "Radish/Mula": {
        season: "Rabi", color: "#FB7185", ndviPeak: 0.50,
        note: "Very fast 25-30 days. Sow repeatedly.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्పतिक", "వృక్ష దశ", [1, 3], [0.20, 0.40], "🌿"),
            stg("Root Dev.", "मूळ विकास", "जड़ विकास", "మూల వృద్ధి", [3, 5], [0.28, 0.48], "🌰"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [5, 7], [0.20, 0.38], "🚜"),
        ]
    },
    "Garlic": {
        season: "Rabi", color: "#FEF9C3", ndviPeak: 0.42,
        note: "Long season 150-180 days. NDVI very low — narrow leaves.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 12], [0.18, 0.38], "🌿"),
            stg("Bulbing", "बल्ब", "बल्ब", "బల్బ్", [12, 20], [0.22, 0.40], "🧄"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [20, 24], [0.15, 0.28], "🟡"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [24, 26], [0.10, 0.22], "🚜"),
        ]
    },
    "Potato": {
        season: "Rabi", color: "#D97706", ndviPeak: 0.72,
        note: "Cool weather. Critical moisture at tuber initiation.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.20], "🌱"),
            stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 5], [0.20, 0.38], "🌿"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.45, 0.68], "🌿"),
            stg("Tuber Init.", "कंद", "कंद", "దుంప", [9, 12], [0.55, 0.72], "🥔"),
            stg("Tuber Fill", "कंद भरणे", "कंद भरना", "దుంప నిండటం", [12, 16], [0.45, 0.65], "🥔"),
            stg("Maturity", "परिपक्वता", "परिपक्वता", "పరిపక్వత", [16, 18], [0.22, 0.38], "🟡"),
            stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [18, 21], [0.10, 0.25], "🚜"),
        ]
    },
    "Methi/Fenugreek": {
        season: "Rabi", color: "#4ADE80", ndviPeak: 0.52,
        note: "Cool season herb. Used as green vegetable and spice.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.22, 0.45], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.38, 0.52], "🌸"),
            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [6, 8], [0.25, 0.42], "🚜"),
        ]
    },
    "Spinach": {
        season: "Rabi", color: "#22C55E", ndviPeak: 0.58,
        note: "Multiple cuts. High nitrogen requirement.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 4], [0.30, 0.55], "🌿"),
            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [4, 8], [0.35, 0.55], "🚜"),
        ]
    },
    "Coriander": {
        season: "Rabi", color: "#86EFAC", ndviPeak: 0.48,
        note: "Short 45-60 days. Often intercropped.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.12], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्పतिक", "వృక్ష దశ", [1, 4], [0.20, 0.42], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.35, 0.48], "🌸"),
            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [6, 8], [0.22, 0.38], "🚜"),
        ]
    },
    "Lauki/Bottle Gourd": {
        season: "Kharif", color: "#6EE7B7", ndviPeak: 0.62,
        note: "Climber. High water but poor drainage tolerance.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"),
            stg("Germination", "उगवण", "अंकुरण", "అంకురం", [2, 3], [0.12, 0.25], "🌿"),
            stg("Vine Growth", "वेल वाढ", "लता वृद्धि", "తీగ వృద్ధి", [3, 6], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 8], [0.45, 0.65], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [8, 12], [0.50, 0.70], "🥗"),
            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [12, 18], [0.35, 0.55], "🚜"),
        ]
    },
    "Bitter Gourd": {
        season: "Kharif", color: "#4D7C0F", ndviPeak: 0.60,
        note: "Climber. Grows fast in warm humid conditions.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"),
            stg("Vine Growth", "वेल वाढ", "लता वृद्धि", "తీగ వృద్ధి", [2, 5], [0.28, 0.52], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.42, 0.60], "🌸"),
            stg("Harvest", "काढणी", "तुड़ाई", "సేకరణ", [7, 14], [0.38, 0.58], "🚜"),
        ]
    },
    "Pumpkin": {
        season: "Kharif", color: "#F97316", ndviPeak: 0.65,
        note: "Heavy vine. Large leaves — high NDVI.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"),
            stg("Vine Growth", "वेल", "लता", "తీగ", [2, 5], [0.30, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 8], [0.48, 0.65], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [8, 14], [0.52, 0.68], "🎃"),
            stg("Harvest", "काढणी", "कटाई", "సేకరణ", [14, 18], [0.30, 0.50], "🚜"),
        ]
    },
    "Cowpea": {
        season: "Kharif", color: "#84CC16", ndviPeak: 0.58,
        note: "Heat and drought tolerant. Fast 60-90 days.",
        stages: [
            stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [1, 5], [0.25, 0.50], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.42, 0.58], "🌸"),
            stg("Pod Fill", "शेंगा", "फलियां", "శింగాలు", [7, 10], [0.38, 0.55], "🌻"),
            stg("Harvest", "काढणी", "कटाई", "కోత", [10, 13], [0.18, 0.32], "🚜"),
        ]
    },

    // ── FRUITS ───────────────────────────────────────────────────────
    "Banana": {
        season: "Kharif", color: "#FBBF24", ndviPeak: 0.72,
        note: "High water demand. Wind-sensitive. 12-15 months.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.20, 0.40], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 20], [0.50, 0.72], "🌿"),
            stg("Shooting", "लोंबी", "शूटिंग", "పుష్పించడం", [20, 28], [0.55, 0.72], "🌿"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [28, 40], [0.48, 0.65], "🍌"),
            stg("Harvest", "काढणी", "कटाई", "కోత", [40, 52], [0.38, 0.55], "🚜"),
        ]
    },
    "Mango": {
        season: "Rabi", color: "#F59E0B", ndviPeak: 0.68,
        note: "Perennial. Flowering requires cool dry spell.",
        stages: [
            stg("Dormancy", "सुप्तावस्था", "सुप्त अवस्था", "నిద్ర", [0, 8], [0.35, 0.50], "🌳"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.38, 0.55], "🌸"),
            stg("Fruit Set", "फळ बांधणी", "फल बंधन", "పండు", [12, 16], [0.45, 0.60], "🥭"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు వృద్ధి", [16, 28], [0.55, 0.68], "🥭"),
            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [28, 34], [0.45, 0.60], "🚜"),
        ]
    },
    "Grape": {
        season: "Rabi", color: "#7C3AED", ndviPeak: 0.62,
        note: "Trellised vine. Critical pruning for berry size.",
        stages: [
            stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 4], [0.10, 0.25], "✂️"),
            stg("Budbreak", "कळी", "अंकुर", "మొగ్గ", [4, 6], [0.18, 0.35], "🌿"),
            stg("Shoot Dev.", "वाढ", "वृद्धि", "అంకురం", [6, 12], [0.40, 0.62], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [12, 15], [0.45, 0.58], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [15, 22], [0.48, 0.62], "🍇"),
            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [22, 28], [0.35, 0.52], "🚜"),
        ]
    },
    "Pomegranate": {
        season: "Kharif", color: "#BE185D", ndviPeak: 0.58,
        note: "Drought tolerant. Prefers dry climate during fruiting.",
        stages: [
            stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 3], [0.10, 0.22], "✂️"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.30, 0.52], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.38, 0.55], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [12, 22], [0.42, 0.58], "🍈"),
            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [22, 28], [0.32, 0.48], "🚜"),
        ]
    },
    "Papaya": {
        season: "Kharif", color: "#F97316", ndviPeak: 0.65,
        note: "Fast fruiting 6-9 months. Wind sensitive. Needs drainage.",
        stages: [
            stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.10, 0.25], "🌱"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [3, 8], [0.40, 0.60], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.45, 0.62], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [12, 20], [0.48, 0.65], "🍈"),
            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [20, 30], [0.38, 0.55], "🚜"),
        ]
    },
    "Orange/Sweet Lime": {
        season: "Rabi", color: "#F97316", ndviPeak: 0.65,
        note: "Vidarbha speciality. Requires stress irrigation for flowering.",
        stages: [
            stg("Dormancy", "विश्राम", "सुप्त", "నిద్ర", [0, 6], [0.38, 0.52], "🌳"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 10], [0.40, 0.55], "🌸"),
            stg("Fruit Set", "फळ बांधणी", "फल बंधन", "పండు", [10, 14], [0.45, 0.60], "🍊"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు వృద్ధి", [14, 28], [0.50, 0.65], "🍊"),
            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [28, 34], [0.42, 0.58], "🚜"),
        ]
    },
    "Guava": {
        season: "Kharif", color: "#86EFAC", ndviPeak: 0.62,
        note: "Two crops/year in India. Hardy and drought tolerant.",
        stages: [
            stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 2], [0.15, 0.28], "✂️"),
            stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.35, 0.55], "🌿"),
            stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 9], [0.42, 0.58], "🌸"),
            stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [9, 16], [0.45, 0.62], "🍈"),
            stg("Harvest", "काढणी", "तुड़ाई", "కోత", [16, 20], [0.38, 0.52], "🚜"),
        ]
    },

    // ── ADDITIONAL CROPS ─────────────────────────────────────────────
    "Watermelon": {
        season: "Zaid", color: "#22C55E", ndviPeak: 0.55, note: "Warm season vine. Needs warm nights for sugar.",
        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.18], "🌱"), stg("Vine Growth", "वेल", "लता", "తీగ", [2, 5], [0.25, 0.50], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [5, 7], [0.40, 0.58], "🌸"), stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు", [7, 12], [0.42, 0.58], "🍉"), stg("Harvest", "काढणी", "कटाई", "కోత", [12, 16], [0.28, 0.45], "🚜")]
    },
    "Muskmelon": {
        season: "Zaid", color: "#FEF08A", ndviPeak: 0.52, note: "Dry heat ideal. Short 80-100 days.",
        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"), stg("Vine Growth", "वेल", "लता", "తీగ", [2, 4], [0.22, 0.45], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.38, 0.52], "🌸"), stg("Harvest", "काढणी", "कटाई", "కోత", [10, 14], [0.25, 0.40], "🚜")]
    },
    "Cucumber": {
        season: "Kharif", color: "#84CC16", ndviPeak: 0.60, note: "Fast 45-55 days. High water at fruit set.",
        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 1], [0.05, 0.15], "🌱"), stg("Vine Growth", "वेल वाढ", "लता", "తీగ", [1, 4], [0.25, 0.50], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [4, 6], [0.42, 0.60], "🌸"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [6, 12], [0.40, 0.58], "🥒")]
    },
    "Capsicum": {
        season: "Rabi", color: "#EF4444", ndviPeak: 0.62, note: "High value export. Temperature 15-25°C ideal.",
        stages: [stg("Nursery", "रोपवाटिका", "नर्सरी", "నర్సరీ", [0, 4], [0.05, 0.18], "🌱"), stg("Transplant", "रोप लावणी", "रोपाई", "నాట్లు", [4, 6], [0.15, 0.30], "🌿"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [6, 10], [0.32, 0.55], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [10, 13], [0.45, 0.62], "🌸"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [13, 22], [0.40, 0.60], "🫑")]
    },
    "Sweet Potato": {
        season: "Kharif", color: "#F97316", ndviPeak: 0.60, note: "Vine crop. Tolerates marginal soils.",
        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 2], [0.05, 0.18], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 8], [0.32, 0.55], "🌿"), stg("Tuber Dev.", "कंद", "कंद", "దుంప", [8, 14], [0.42, 0.60], "🍠"), stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [14, 18], [0.28, 0.45], "🚜")]
    },
    "Potato": {
        season: "Rabi", color: "#D97706", ndviPeak: 0.72, note: "Cool weather. Critical moisture at tuber initiation.",
        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 3], [0.05, 0.20], "🌱"), stg("Emergence", "उगवण", "उगाव", "అంకురం", [3, 5], [0.20, 0.38], "🌿"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [5, 9], [0.45, 0.68], "🌿"), stg("Tuber Fill", "कंद भरणे", "कंद भरना", "దుంప నిండటం", [9, 16], [0.45, 0.65], "🥔"), stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [16, 21], [0.10, 0.25], "🚜")]
    },
    "Coconut": {
        season: "Perennial", color: "#78716C", ndviPeak: 0.70, note: "Perennial palm. Sandy coastal soils.",
        stages: [stg("Young", "तरुण", "युवा", "యువ", [0, 52], [0.40, 0.60], "🌴"), stg("Bearing", "फळधारणा", "फलन", "కాపు", [52, 260], [0.55, 0.72], "🥥")]
    },
    "Coffee": {
        season: "Perennial", color: "#78350F", ndviPeak: 0.68, note: "Shade grown. Altitude 600-1600m ideal.",
        stages: [stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [0, 52], [0.45, 0.65], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [52, 60], [0.50, 0.68], "🌸"), stg("Harvest", "काढणी", "कटाई", "కోత", [78, 86], [0.42, 0.58], "🚜")]
    },
    "Orange": {
        season: "Rabi", color: "#F97316", ndviPeak: 0.65, note: "Vidarbha speciality. Stress irrigation for flowering.",
        stages: [stg("Dormancy", "विश्राम", "सुप्त", "నిద్ర", [0, 6], [0.38, 0.52], "🌳"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [6, 10], [0.40, 0.55], "🌸"), stg("Fruit Dev.", "फळ विकास", "फल विकास", "పండు వృద్ధి", [14, 28], [0.50, 0.65], "🍊"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [28, 34], [0.42, 0.58], "🚜")]
    },
    "Guava": {
        season: "Kharif", color: "#86EFAC", ndviPeak: 0.62, note: "Two crops/year. Hardy and drought tolerant.",
        stages: [stg("Pruning", "छाटणी", "छंटाई", "కత్తిరించడం", [0, 2], [0.15, 0.28], "✂️"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.35, 0.55], "🌿"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [16, 20], [0.38, 0.52], "🚜")]
    },
    "Lemon": {
        season: "Perennial", color: "#FEF08A", ndviPeak: 0.62, note: "Year-round fruiting. Needs regular moisture.",
        stages: [stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [0, 8], [0.38, 0.55], "🌿"), stg("Flowering", "फुलोरा", "फूल आना", "పూత", [8, 12], [0.42, 0.58], "🌸"), stg("Harvest", "काढणी", "तुड़ाई", "కోత", [24, 28], [0.38, 0.52], "🚜")]
    },
    "Moringa": {
        season: "Kharif", color: "#4ADE80", ndviPeak: 0.62, note: "Nutritional powerhouse. Fast growing. Drought hardy.",
        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.08, 0.22], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 16], [0.35, 0.58], "🌿"), stg("Harvest", "काढणी", "कटाई", "కోత", [16, 52], [0.40, 0.62], "🚜")]
    },
    "Aloe Vera": {
        season: "Kharif", color: "#86EFAC", ndviPeak: 0.48, note: "Medicinal. Very drought tolerant. Sandy soils.",
        stages: [stg("Planting", "लागवड", "रोपण", "నాటడం", [0, 4], [0.10, 0.25], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [4, 20], [0.25, 0.48], "🌿"), stg("Harvest", "काढणी", "कटाई", "కోత", [20, 26], [0.22, 0.42], "🚜")]
    },
    "Isabgol": {
        season: "Rabi", color: "#F9F9F0", ndviPeak: 0.45, note: "Medicinal. Cool dry climate. Low NDVI.",
        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 6], [0.18, 0.38], "🌿"), stg("Harvest", "काढणी", "कटाई", "కోత", [9, 11], [0.15, 0.28], "🚜")]
    },
    "Ashwagandha": {
        season: "Kharif", color: "#D97706", ndviPeak: 0.48, note: "Medicinal shrub. Sandy loam soils. 150-180 days.",
        stages: [stg("Sowing", "पेरणी", "बुआई", "విత్తనం", [0, 2], [0.05, 0.15], "🌱"), stg("Vegetative", "वनस्पती", "वानस्पतिक", "వృక్ష దశ", [2, 10], [0.22, 0.45], "🌿"), stg("Harvest", "काढणी", "खुदाई", "తవ్వడం", [16, 22], [0.18, 0.35], "🚜")]
    },
    "Mixed Orchard": {
        season: "Perennial", color: "#22D3EE", ndviPeak: 0.65, note: "Multiple fruit tree varieties.",
        stages: [stg("Active", "सक्रिय", "सक्रिय", "చురుకు", [0, 52], [0.45, 0.70], "🌳")]
    },
    "Teak": {
        season: "Perennial", color: "#92400E", ndviPeak: 0.70, note: "Timber crop. 15-20 year rotation.",
        stages: [stg("Plantation", "लागवड", "रोपण", "నాటడం", [0, 52], [0.20, 0.45], "🌱"), stg("Growing", "वाढ", "वृद्धि", "వృద్ధి", [52, 520], [0.55, 0.72], "🌳")]
    },
    "Fallow/Bare": {
        season: "Kharif", color: "#b8d0e8", ndviPeak: 0.08, note: "No crop. Bare soil or early fallow.",
        stages: [stg("Bare", "पडीत", "परती", "బీడు", [0, 52], [0.02, 0.12], "🟫")]
    },
    // ── KARDAI / SAFFLOWER (Maharashtra specialty oilseed) ────────────
    "Kardai/Safflower": {
        season: "Rabi", color: "#FF8C42", ndviPeak: 0.55,
        note: "Maharashtra #1 Rabi oilseed after Soybean. Drought hardy. 120-140 days.",
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Rosette", mr: "रोझेट अवस्था", hi: "रोसेट", te: "రోసెట్", weeks: [2, 5], ndviRange: [0.15, 0.35], icon: "🌿" },
            { name: "Branching", mr: "फांदी येणे", hi: "शाखाएं", te: "కొమ్మలు", weeks: [5, 9], ndviRange: [0.32, 0.52], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [9, 12], ndviRange: [0.42, 0.60], icon: "🌸" },
            { name: "Seed Fill", mr: "बीज भरणे", hi: "बीज भरना", te: "విత్తన నిండటం", weeks: [12, 16], ndviRange: [0.35, 0.52], icon: "🌻" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [16, 20], ndviRange: [0.18, 0.32], icon: "🚜" },
        ]
    },
    "Javas/Linseed": {
        season: "Rabi", color: "#93C5FD", ndviPeak: 0.52,
        note: "Linseed known as 'Javas' in Maharashtra. Dual-use: oil + fibre. 100-120 days.",
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.20, 0.42], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 8], ndviRange: [0.40, 0.55], icon: "🌸" },
            { name: "Capsule", mr: "कॅप्सूल", hi: "कैप्सूल", te: "క్యాప్సూల్", weeks: [8, 11], ndviRange: [0.35, 0.50], icon: "🌻" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [11, 14], ndviRange: [0.15, 0.28], icon: "🚜" },
        ]
    },

    // ── ADDITIONAL CROPS V5.4.0 (farmer requested + Maharashtra specialty) ──

    "Kardai/Safflower": {
        season: "Rabi", color: "#FF8C42", ndviPeak: 0.55,
        note: "Maharashtra #1 Rabi oilseed. 90-110 days. Drought hardy. Spiny varieties.",
        alertThresholds: { ndvi_stress: 0.22, moisture_low: 25, moisture_high: 70 },
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Rosette", mr: "रोझेट अवस्था", hi: "रोसेट", te: "రోసెట్", weeks: [2, 5], ndviRange: [0.15, 0.38], icon: "🌿" },
            { name: "Branching", mr: "फांदी येणे", hi: "शाखाएं", te: "కొమ్మలు", weeks: [5, 9], ndviRange: [0.35, 0.55], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [9, 12], ndviRange: [0.42, 0.62], icon: "🌸" },
            { name: "Seed Fill", mr: "बीज भरणे", hi: "बीज भरना", te: "విత్తన నిండటం", weeks: [12, 16], ndviRange: [0.32, 0.52], icon: "🌻" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [16, 20], ndviRange: [0.15, 0.30], icon: "🚜" },
        ]
    },
    "Ajwain/Carom": {
        season: "Rabi", color: "#D4A017", ndviPeak: 0.48,
        note: "Spice crop. Cool dry climate. 120-150 days. Rajasthan & Maharashtra.",
        alertThresholds: { ndvi_stress: 0.18, moisture_low: 20, moisture_high: 60 },
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 7], ndviRange: [0.20, 0.42], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [7, 10], ndviRange: [0.35, 0.50], icon: "🌸" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [10, 14], ndviRange: [0.18, 0.32], icon: "🚜" },
        ]
    },
    "Jeera/Cumin": {
        season: "Rabi", color: "#C8B400", ndviPeak: 0.45,
        note: "Spice crop. Low water. Gujarat & Maharashtra. Very low NDVI — thin leaves.",
        alertThresholds: { ndvi_stress: 0.15, moisture_low: 18, moisture_high: 55 },
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.18, 0.38], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 9], ndviRange: [0.30, 0.45], icon: "🌸" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [9, 12], ndviRange: [0.15, 0.28], icon: "🚜" },
        ]
    },
    "Dhania/Coriander Seed": {
        season: "Rabi", color: "#8FBC8F", ndviPeak: 0.48,
        note: "Seed coriander for spice. Maharashtra, MP. Cool dry climate.",
        alertThresholds: { ndvi_stress: 0.18, moisture_low: 20, moisture_high: 60 },
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 5], ndviRange: [0.20, 0.42], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [5, 7], ndviRange: [0.35, 0.48], icon: "🌸" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [7, 10], ndviRange: [0.20, 0.35], icon: "🚜" },
        ]
    },
    "Lemongrass": {
        season: "Kharif", color: "#78C850", ndviPeak: 0.65,
        note: "Essential oil crop. Perennial. Low maintenance. Drought tolerant.",
        alertThresholds: { ndvi_stress: 0.25, moisture_low: 22, moisture_high: 65 },
        stages: [
            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 4], ndviRange: [0.10, 0.30], icon: "🌱" },
            { name: "Active", mr: "वाढ", hi: "वृद्धि", te: "వృద్ధి", weeks: [4, 24], ndviRange: [0.45, 0.65], icon: "🌿" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [24, 52], ndviRange: [0.40, 0.60], icon: "🚜" },
        ]
    },
    "Stevia": {
        season: "Kharif", color: "#90EE90", ndviPeak: 0.58,
        note: "Zero-calorie sweetener. High-value export crop. Maharashtra growing.",
        alertThresholds: { ndvi_stress: 0.22, moisture_low: 28, moisture_high: 70 },
        stages: [
            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 3], ndviRange: [0.10, 0.28], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [3, 10], ndviRange: [0.35, 0.58], icon: "🌿" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [10, 52], ndviRange: [0.40, 0.58], icon: "🚜" },
        ]
    },
    "Strawberry": {
        season: "Rabi", color: "#FF6B6B", ndviPeak: 0.60,
        note: "Mahabaleshwar specialty. Cool climate 15-25°C. High value.",
        alertThresholds: { ndvi_stress: 0.22, moisture_low: 30, moisture_high: 70 },
        stages: [
            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 3], ndviRange: [0.10, 0.28], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [3, 6], ndviRange: [0.30, 0.55], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 9], ndviRange: [0.40, 0.60], icon: "🌸" },
            { name: "Fruiting", mr: "फळे", hi: "फल", te: "పండు", weeks: [9, 18], ndviRange: [0.42, 0.60], icon: "🍓" },
            { name: "Harvest", mr: "काढणी", hi: "तुड़ाई", te: "కోత", weeks: [18, 24], ndviRange: [0.35, 0.55], icon: "🚜" },
        ]
    },
    "Fig/Anjeer": {
        season: "Perennial", color: "#9370DB", ndviPeak: 0.62,
        note: "Pune/Solapur specialty. Drought hardy. High export value.",
        alertThresholds: { ndvi_stress: 0.25, moisture_low: 25, moisture_high: 65 },
        stages: [
            { name: "Dormancy", mr: "सुप्तावस्था", hi: "सुप्त", te: "నిద్ర", weeks: [0, 4], ndviRange: [0.20, 0.38], icon: "🌳" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [4, 12], ndviRange: [0.40, 0.62], icon: "🌿" },
            { name: "Fruit", mr: "फळे", hi: "फल", te: "పండు", weeks: [12, 24], ndviRange: [0.42, 0.62], icon: "🫐" },
        ]
    },
    "Drumstick/Moringa": {
        season: "Kharif", color: "#32CD32", ndviPeak: 0.62,
        note: "Nutritional powerhouse. Fast growing. Drought hardy. Year-round harvest.",
        alertThresholds: { ndvi_stress: 0.22, moisture_low: 20, moisture_high: 65 },
        stages: [
            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 4], ndviRange: [0.08, 0.25], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [4, 16], ndviRange: [0.35, 0.60], icon: "🌿" },
            { name: "Pod Harvest", mr: "शेंगा काढणी", hi: "सहजन", te: "మునగ", weeks: [16, 52], ndviRange: [0.40, 0.62], icon: "🚜" },
        ]
    },
    "Beetroot": {
        season: "Rabi", color: "#DC143C", ndviPeak: 0.55,
        note: "Root vegetable. Cool climate. High water demand at root development.",
        alertThresholds: { ndvi_stress: 0.20, moisture_low: 30, moisture_high: 75 },
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.22, 0.48], icon: "🌿" },
            { name: "Root Dev.", mr: "मुळे भरणे", hi: "जड़ विकास", te: "మూల వృద్ధి", weeks: [6, 10], ndviRange: [0.35, 0.55], icon: "🫀" },
            { name: "Harvest", mr: "काढणी", hi: "खुदाई", te: "తవ్వడం", weeks: [10, 14], ndviRange: [0.25, 0.42], icon: "🚜" },
        ]
    },
    "Cluster Bean/Guar": {
        season: "Kharif", color: "#7CFC00", ndviPeak: 0.58,
        note: "Industrial gum crop + vegetable. Drought tolerant. Maharashtra, Rajasthan.",
        alertThresholds: { ndvi_stress: 0.20, moisture_low: 18, moisture_high: 60 },
        stages: [
            { name: "Sowing", mr: "पेरणी", hi: "बुआई", te: "విత్తనం", weeks: [0, 2], ndviRange: [0.05, 0.15], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [2, 6], ndviRange: [0.28, 0.52], icon: "🌿" },
            { name: "Flowering", mr: "फुलोरा", hi: "फूल आना", te: "పూత", weeks: [6, 8], ndviRange: [0.42, 0.58], icon: "🌸" },
            { name: "Pod Fill", mr: "शेंगा", hi: "फलियां", te: "శింగాలు", weeks: [8, 12], ndviRange: [0.38, 0.55], icon: "🌻" },
            { name: "Harvest", mr: "कापणी", hi: "कटाई", te: "కోత", weeks: [12, 15], ndviRange: [0.18, 0.35], icon: "🚜" },
        ]
    },
    "Taro/Arbi": {
        season: "Kharif", color: "#9ACD32", ndviPeak: 0.68,
        note: "Corm crop. High moisture. Shade tolerant. Kerala, Maharashtra.",
        alertThresholds: { ndvi_stress: 0.28, moisture_low: 40, moisture_high: 85 },
        stages: [
            { name: "Planting", mr: "लागवड", hi: "रोपण", te: "నాటడం", weeks: [0, 3], ndviRange: [0.10, 0.28], icon: "🌱" },
            { name: "Vegetative", mr: "वनस्पती", hi: "वानस्पतिक", te: "వృక్ష దశ", weeks: [3, 16], ndviRange: [0.45, 0.68], icon: "🌿" },
            { name: "Maturity", mr: "परिपक्वता", hi: "परिपक्वता", te: "పరిపక్వత", weeks: [16, 24], ndviRange: [0.35, 0.55], icon: "🟡" },
            { name: "Harvest", mr: "काढणी", hi: "खुदाई", te: "తవ్వడం", weeks: [24, 28], ndviRange: [0.18, 0.35], icon: "🚜" },
        ]
    },

    // ── CATCH-ALL ────────────────────────────────────────────────────
    "Unknown": {
        season: "—", color: "#b8d0e8", ndviPeak: 0.50,
        note: "Crop not identified. Run scan for detection.",
        stages: []
    },
};

// ── CROP_YIELD_PARAMS ────────────────────────────────────────────
// Source: Maharashtra Agriculture Dept + ICAR benchmarks
// {season_base_kg_ha, ndvi_ref, harvest_index, rue g_C/MJ}
export const CROP_YIELD_PARAMS = {
    "Rice": { Kharif: 2500, Rabi: 2200, Zaid: 2000, ndvi_ref: 0.65, hi: 0.50, rue: 1.8 },
    "Wheat": { Kharif: 2500, Rabi: 3000, Zaid: 2200, ndvi_ref: 0.68, hi: 0.48, rue: 2.0 },
    "Maize/Corn": { Kharif: 3500, Rabi: 3200, Zaid: 3000, ndvi_ref: 0.72, hi: 0.50, rue: 2.2 },
    "Jowar/Sorghum": { Kharif: 1800, Rabi: 1600, Zaid: 1400, ndvi_ref: 0.62, hi: 0.42, rue: 1.6 },
    "Bajra/Millet": { Kharif: 1500, Rabi: 1400, Zaid: 1200, ndvi_ref: 0.58, hi: 0.40, rue: 1.5 },
    "Ragi/Finger Millet": { Kharif: 1400, Rabi: 1300, Zaid: 1100, ndvi_ref: 0.55, hi: 0.38, rue: 1.4 },
    "Barley": { Kharif: 2000, Rabi: 2500, Zaid: 1800, ndvi_ref: 0.60, hi: 0.45, rue: 1.8 },
    "Sugarcane": { Kharif: 70000, Rabi: 75000, Zaid: 65000, ndvi_ref: 0.78, hi: 0.90, rue: 3.0 },
    "Cotton": { Kharif: 500, Rabi: 500, Zaid: 450, ndvi_ref: 0.60, hi: 0.40, rue: 1.5 },
    "Soybean": { Kharif: 1200, Rabi: 1000, Zaid: 900, ndvi_ref: 0.65, hi: 0.45, rue: 1.6 },
    "Groundnut": { Kharif: 1500, Rabi: 1400, Zaid: 1200, ndvi_ref: 0.62, hi: 0.42, rue: 1.5 },
    "Sunflower": { Kharif: 1200, Rabi: 1100, Zaid: 1000, ndvi_ref: 0.65, hi: 0.40, rue: 1.6 },
    "Mustard/Rapeseed": { Kharif: 900, Rabi: 1200, Zaid: 800, ndvi_ref: 0.58, hi: 0.38, rue: 1.4 },
    "Sesame/Til": { Kharif: 600, Rabi: 550, Zaid: 500, ndvi_ref: 0.52, hi: 0.35, rue: 1.2 },
    "Castor": { Kharif: 1200, Rabi: 1100, Zaid: 900, ndvi_ref: 0.60, hi: 0.42, rue: 1.5 },
    "Linseed/Flax": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.52, hi: 0.38, rue: 1.3 },
    "Gram/Chickpea": { Kharif: 900, Rabi: 1100, Zaid: 800, ndvi_ref: 0.42, hi: 0.40, rue: 1.2 },
    "Tur/Pigeon Pea": { Kharif: 1200, Rabi: 1000, Zaid: 900, ndvi_ref: 0.55, hi: 0.38, rue: 1.3 },
    "Moong/Green Gram": { Kharif: 700, Rabi: 650, Zaid: 600, ndvi_ref: 0.48, hi: 0.35, rue: 1.1 },
    "Udid/Black Gram": { Kharif: 650, Rabi: 600, Zaid: 550, ndvi_ref: 0.45, hi: 0.35, rue: 1.1 },
    "Masoor/Lentil": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.44, hi: 0.36, rue: 1.2 },
    "Rajma/Kidney Bean": { Kharif: 1000, Rabi: 900, Zaid: 850, ndvi_ref: 0.58, hi: 0.38, rue: 1.3 },
    "Cowpea": { Kharif: 800, Rabi: 750, Zaid: 700, ndvi_ref: 0.52, hi: 0.36, rue: 1.2 },
    "Onion": { Kharif: 20000, Rabi: 25000, Zaid: 18000, ndvi_ref: 0.30, hi: 0.80, rue: 2.5 },
    "Tomato": { Kharif: 25000, Rabi: 30000, Zaid: 22000, ndvi_ref: 0.62, hi: 0.70, rue: 2.2 },
    "Chilli": { Kharif: 8000, Rabi: 8500, Zaid: 7000, ndvi_ref: 0.58, hi: 0.65, rue: 1.8 },
    "Brinjal/Eggplant": { Kharif: 18000, Rabi: 20000, Zaid: 16000, ndvi_ref: 0.62, hi: 0.70, rue: 2.0 },
    "Bhendi/Okra": { Kharif: 7000, Rabi: 7500, Zaid: 6000, ndvi_ref: 0.55, hi: 0.65, rue: 1.7 },
    "Cauliflower": { Kharif: 12000, Rabi: 15000, Zaid: 10000, ndvi_ref: 0.55, hi: 0.72, rue: 1.8 },
    "Cabbage": { Kharif: 15000, Rabi: 18000, Zaid: 12000, ndvi_ref: 0.60, hi: 0.75, rue: 1.9 },
    "Carrot": { Kharif: 15000, Rabi: 18000, Zaid: 12000, ndvi_ref: 0.52, hi: 0.72, rue: 1.7 },
    "Radish/Mula": { Kharif: 12000, Rabi: 15000, Zaid: 10000, ndvi_ref: 0.48, hi: 0.75, rue: 1.6 },
    "Garlic": { Kharif: 7000, Rabi: 8000, Zaid: 6000, ndvi_ref: 0.38, hi: 0.78, rue: 1.5 },
    "Potato": { Kharif: 18000, Rabi: 22000, Zaid: 16000, ndvi_ref: 0.68, hi: 0.75, rue: 2.2 },
    "Methi/Fenugreek": { Kharif: 1000, Rabi: 1200, Zaid: 900, ndvi_ref: 0.48, hi: 0.60, rue: 1.3 },
    "Bitter Gourd": { Kharif: 8000, Rabi: 8500, Zaid: 7000, ndvi_ref: 0.58, hi: 0.65, rue: 1.7 },
    "Pumpkin": { Kharif: 12000, Rabi: 14000, Zaid: 10000, ndvi_ref: 0.62, hi: 0.70, rue: 1.8 },
    "Lauki/Bottle Gourd": { Kharif: 10000, Rabi: 12000, Zaid: 8000, ndvi_ref: 0.58, hi: 0.68, rue: 1.7 },
    "Turmeric": { Kharif: 15000, Rabi: 14000, Zaid: 12000, ndvi_ref: 0.68, hi: 0.85, rue: 2.0 },
    "Ginger": { Kharif: 18000, Rabi: 16000, Zaid: 14000, ndvi_ref: 0.65, hi: 0.82, rue: 1.9 },
    "Banana": { Kharif: 35000, Rabi: 32000, Zaid: 30000, ndvi_ref: 0.70, hi: 0.88, rue: 2.8 },
    "Mango": { Kharif: 8000, Rabi: 10000, Zaid: 7000, ndvi_ref: 0.65, hi: 0.85, rue: 2.0 },
    "Grape": { Kharif: 15000, Rabi: 18000, Zaid: 14000, ndvi_ref: 0.60, hi: 0.88, rue: 2.2 },
    "Pomegranate": { Kharif: 12000, Rabi: 14000, Zaid: 10000, ndvi_ref: 0.55, hi: 0.85, rue: 1.9 },
    "Papaya": { Kharif: 35000, Rabi: 32000, Zaid: 28000, ndvi_ref: 0.62, hi: 0.86, rue: 2.5 },
    "Orange/Sweet Lime": { Kharif: 10000, Rabi: 12000, Zaid: 9000, ndvi_ref: 0.62, hi: 0.82, rue: 2.0 },
    "Guava": { Kharif: 12000, Rabi: 14000, Zaid: 10000, ndvi_ref: 0.60, hi: 0.82, rue: 1.9 },
    "Sugarcane": { Kharif: 70000, Rabi: 75000, Zaid: 65000, ndvi_ref: 0.78, hi: 0.90, rue: 3.0 },
    "Tobacco": { Kharif: 1800, Rabi: 2000, Zaid: 1600, ndvi_ref: 0.62, hi: 0.72, rue: 1.7 },
    "Jute": { Kharif: 2000, Rabi: 1800, Zaid: 1600, ndvi_ref: 0.70, hi: 0.80, rue: 2.0 },
    "Castor": { Kharif: 1200, Rabi: 1100, Zaid: 900, ndvi_ref: 0.60, hi: 0.42, rue: 1.5 },
    "Spinach": { Kharif: 8000, Rabi: 10000, Zaid: 7000, ndvi_ref: 0.55, hi: 0.80, rue: 1.6 },
    "Coriander": { Kharif: 700, Rabi: 900, Zaid: 600, ndvi_ref: 0.45, hi: 0.65, rue: 1.2 },
    "Kardai/Safflower": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.52, hi: 0.36, rue: 1.3 },
    "Javas/Linseed": { Kharif: 700, Rabi: 900, Zaid: 650, ndvi_ref: 0.50, hi: 0.36, rue: 1.3 },
    "Kardai/Safflower": { Kharif: 700, Rabi: 900, Zaid: 600, ndvi_ref: 0.52, hi: 0.36, rue: 1.3 },
    "Ajwain/Carom": { Kharif: 600, Rabi: 800, Zaid: 500, ndvi_ref: 0.45, hi: 0.60, rue: 1.2 },
    "Jeera/Cumin": { Kharif: 500, Rabi: 700, Zaid: 450, ndvi_ref: 0.42, hi: 0.60, rue: 1.2 },
    "Dhania/Coriander Seed": { Kharif: 600, Rabi: 800, Zaid: 500, ndvi_ref: 0.45, hi: 0.65, rue: 1.2 },
    "Lemongrass": { Kharif: 15000, Rabi: 14000, Zaid: 12000, ndvi_ref: 0.60, hi: 0.80, rue: 1.6 },
    "Stevia": { Kharif: 8000, Rabi: 8000, Zaid: 7000, ndvi_ref: 0.55, hi: 0.75, rue: 1.5 },
    "Strawberry": { Kharif: 12000, Rabi: 15000, Zaid: 10000, ndvi_ref: 0.58, hi: 0.82, rue: 1.8 },
    "Fig/Anjeer": { Kharif: 10000, Rabi: 12000, Zaid: 9000, ndvi_ref: 0.60, hi: 0.84, rue: 1.8 },
    "Drumstick/Moringa": { Kharif: 18000, Rabi: 16000, Zaid: 14000, ndvi_ref: 0.60, hi: 0.82, rue: 1.9 },
    "Beetroot": { Kharif: 20000, Rabi: 25000, Zaid: 18000, ndvi_ref: 0.52, hi: 0.78, rue: 1.7 },
    "Cluster Bean/Guar": { Kharif: 1000, Rabi: 900, Zaid: 800, ndvi_ref: 0.55, hi: 0.40, rue: 1.3 },
    "Taro/Arbi": { Kharif: 18000, Rabi: 16000, Zaid: 14000, ndvi_ref: 0.65, hi: 0.82, rue: 2.0 },
    "Unknown": { Kharif: 1500, Rabi: 1500, Zaid: 1200, ndvi_ref: 0.50, hi: 0.45, rue: 1.5 },
};

// ── Crop display name in 4 languages ────────────────────────────
export const CROP_NAMES_L10N = {
    "Rice": { mr: "भात", hi: "चावल", te: "వరి" },
    "Wheat": { mr: "गहू", hi: "गेहूं", te: "గోధుమ" },
    "Maize/Corn": { mr: "मका", hi: "मक्का", te: "మొక్కజొన్న" },
    "Jowar/Sorghum": { mr: "ज्वारी", hi: "ज्वार", te: "జొన్న" },
    "Bajra/Millet": { mr: "बाजरा", hi: "बाजरा", te: "సజ్జ" },
    "Sugarcane": { mr: "ऊस", hi: "गन्ना", te: "చెరకు" },
    "Cotton": { mr: "कापूस", hi: "कपास", te: "పత్తి" },
    "Soybean": { mr: "सोयाबीन", hi: "सोयाबीन", te: "సోయాబీన్" },
    "Groundnut": { mr: "भुईमूग", hi: "मूंगफली", te: "వేరుశనగ" },
    "Onion": { mr: "कांदा", hi: "प्याज", te: "ఉల్లి" },
    "Tomato": { mr: "टोमॅटो", hi: "टमाटर", te: "టొమాటో" },
    "Chilli": { mr: "मिरची", hi: "मिर्च", te: "మిరప" },
    "Turmeric": { mr: "हळद", hi: "हल्दी", te: "పసుపు" },
    "Ginger": { mr: "आले", hi: "अदरक", te: "అల్లం" },
    "Gram/Chickpea": { mr: "हरभरा", hi: "चना", te: "శనగ" },
    "Tur/Pigeon Pea": { mr: "तूर", hi: "अरहर", te: "కంది" },
    "Banana": { mr: "केळ", hi: "केला", te: "అరటి" },
    "Mango": { mr: "आंबा", hi: "आम", te: "మామిడి" },
    "Grape": { mr: "द्राक्षा", hi: "अंगूर", te: "ద్రాక్ష" },
    "Pomegranate": { mr: "डाळिंब", hi: "अनार", te: "దానిమ్మ" },
    "Papaya": { mr: "पपई", hi: "पपीता", te: "బొప్పాయి" },
    "Potato": { mr: "बटाटा", hi: "आलू", te: "బంగాళాదుంప" },
    "Mustard/Rapeseed": { mr: "मोहरी", hi: "सरसों", te: "ఆవాలు" },
    "Sunflower": { mr: "सूर्यफूल", hi: "सूरजमुखी", te: "పొద్దుతిరుగుడు" },
    "Kardai/Safflower": { mr: "कर्डई", hi: "कुसुम", te: "కుసుమ" },
    "Javas/Linseed": { mr: "जवस", hi: "अलसी", te: "అవిసె" },
    // Farmer-friendly Marathi names for existing crops (aliases)
    "Sesame/Til": { mr: "तीळ", hi: "तिल", te: "నువ్వులు" },
    "Moong/Green Gram": { mr: "मूग", hi: "मूंग", te: "పెసలు" },
    "Udid/Black Gram": { mr: "उडीद", hi: "उड़द", te: "మినుములు" },
    "Gram/Chickpea": { mr: "हरभरा", hi: "चना", te: "శనగ" },
    "Cowpea": { mr: "चवळी", hi: "लोबिया", te: "అలసంద" },
    "Rajma/Kidney Bean": { mr: "राजमा", hi: "राजमा", te: "రాజ్మా" },
    "Tur/Pigeon Pea": { mr: "तूर", hi: "अरहर", te: "కంది" },
    "Linseed/Flax": { mr: "जवस", hi: "अलसी", te: "అవిసె" },
    "Mustard/Rapeseed": { mr: "मोहरी", hi: "सरसों", te: "ఆవాలు" },
    "Kardai/Safflower": { mr: "कर्डई", hi: "कुसुम", te: "కుసుమ" },
    "Ajwain/Carom": { mr: "ओवा", hi: "अजवाइन", te: "వాము" },
    "Jeera/Cumin": { mr: "जिरे", hi: "जीरा", te: "జీలకర్ర" },
    "Dhania/Coriander Seed": { mr: "धणे", hi: "धनिया", te: "ధనియాలు" },
    "Lemongrass": { mr: "लिंबुगवत", hi: "नींबू घास", te: "నిమ్మ గడ్డి" },
    "Stevia": { mr: "स्टेव्हिया", hi: "स्टेविया", te: "స్టీవియా" },
    "Strawberry": { mr: "स्ट्रॉबेरी", hi: "स्ट्रॉबेरी", te: "స్ట్రాబెర్రీ" },
    "Fig/Anjeer": { mr: "अंजीर", hi: "अंजीर", te: "అత్తి" },
    "Drumstick/Moringa": { mr: "शेवगा", hi: "सहजन", te: "మునగ" },
    "Beetroot": { mr: "बीट", hi: "चुकंदर", te: "దుంప" },
    "Cluster Bean/Guar": { mr: "ग्वार", hi: "ग्वार", te: "గోరుచిక్కుడు" },
    "Taro/Arbi": { mr: "अळू", hi: "अरबी", te: "చేమదుంప" },
    // Farmer Marathi aliases for existing crops
    "Sesame/Til": { mr: "तीळ", hi: "तिल", te: "నువ్వులు" },
    "Linseed/Flax": { mr: "जवस", hi: "अलसी", te: "అవిసె" },
    "Rajma/Kidney Bean": { mr: "राजमा", hi: "राजमा", te: "రాజ్మా" },
    "Moong/Green Gram": { mr: "मूग", hi: "मूंग", te: "పెసలు" },
    "Mustard/Rapeseed": { mr: "मोहरी", hi: "सरसों", te: "ఆవాలు" },
    "Udid/Black Gram": { mr: "उडीद", hi: "उड़द", te: "మినుములు" },
    "Gram/Chickpea": { mr: "हरभरा", hi: "चना", te: "శనగ" },
    "Cowpea": { mr: "चवळी", hi: "लोबिया", te: "అలసంద" },
};

// ── Helper: get localised crop name ─────────────────────────────
export const getCropName = (key, lang) => {
    const entry = CROP_NAMES_L10N[key];
    if (!entry) return key;
    return entry[lang] || key;
};

// ── List of all crop keys (for dropdowns / searches) ────────────
export const CROP_KEYS = Object.keys(CROP_CALENDAR).filter(k => k !== 'Unknown');
